import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
  useMemo,
} from "react";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { isNil } from "lodash";
import {
  Fade
} from "@material-ui/core";
import {
  CircularProgress,
  ClickAwayListener,
  IconButton,
  InputBase,
  makeStyles,
  Paper,
  Hidden,
  Menu,
  MenuItem,
  Tooltip,
  Fab,
  Chip,
  Box,
  Popper,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { blue, green, pink, grey } from "@material-ui/core/colors";
import {
  AttachFile,
  CheckCircleOutline,
  Clear,
  Comment,
  Create,
  Description,
  HighlightOff,
  Mic,
  Mood,
  MoreVert,
  Send,
  PermMedia,
  Person,
  Reply,
  Duo,
  Timer,
  WhatsApp,
  Info,
  AccountTree
} from "@material-ui/icons";

import {
  FormatBold as FormatBoldIcon,
  FormatItalic as FormatItalicIcon,
  FormatStrikethrough as FormatStrikethroughIcon,
  Code as CodeIcon,
  FormatListNumbered as FormatListNumberedIcon,
  FormatListBulleted as FormatListBulletedIcon,
  FormatQuote as FormatQuoteIcon,
  FormatClear as FormatClearIcon,
} from "@material-ui/icons";

import AddIcon from "@material-ui/icons/Add";
import { CameraAlt } from "@material-ui/icons";
import MicRecorder from "mic-recorder-to-mp3";
import clsx from "clsx";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import { showErrorToast, showInfoToast } from "../../utils/toastHelper";
import api, { openApi } from "../../services/api";
import RecordingTimer from "./RecordingTimer";

import useQuickMessages from "../../hooks/useQuickMessages";
import { isString, isEmpty } from "lodash";
import ContactSendModal from "../ContactSendModal";
import CameraModal from "../CameraModal";
import axios from "axios";

import useCompanySettings from "../../hooks/useSettings/companySettings";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import {
  getStoredCompanyTimezone,
  resolveCompanyTimezone
} from "../../utils/companyTimezone";
import moment from "moment-timezone";
import MessageUploadMedias from "../MessageUploadMedias";
import { EditMessageContext } from "../../context/EditingMessage/EditingMessageContext";
import ScheduleModal from "../ScheduleModal";
import usePlans from "../../hooks/usePlans";
import TemplateModal from "../TemplateMetaModal";
import TriggerFlowModal from "../TriggerFlowModal";
import { getEmojiMartI18n } from "../../utils/emojiMartI18n";
import AudioModal from "../AudioModal";


const Mp3Recorder = new MicRecorder({
  bitRate: 128,
  sampleRate: 44100
});

const isMobileDevice = () => {
  return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    background: "transparent",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: "none",
    padding: "8px 16px 16px 16px",
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      bottom: 0,
      width: "100%",
    },
  },
  "@keyframes pulse": {
    "0%": {
      boxShadow: "0 0 0 0 rgba(25, 118, 210, 0.7)",
    },
    "70%": {
      boxShadow: "0 0 0 10px rgba(25, 118, 210, 0)",
    },
    "100%": {
      boxShadow: "0 0 0 0 rgba(25, 118, 210, 0)",
    },
  },
  avatar: {
    width: "50px",
    height: "50px",
    borderRadius: "25%",
  },
  dropInfo: {
    background: "#eee",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    padding: 15,
    left: 0,
    right: 0,
  },
  dropInfoOut: {
    display: "none",
  },
  gridFiles: {
    maxHeight: "100%",
    overflow: "scroll",
  },
  newMessageBox: {
    background: "transparent",
    width: "100%",
    display: "flex",
    padding: "0px",
    alignItems: "center",
  },
  messageInputWrapper: {
    padding: 8,
    marginRight: 7,
    display: "flex",
    borderRadius: 24,
    flex: 1,
    position: "relative",
    zIndex: 10,
    border: "none",
    backgroundColor: theme.mode === "light" ? "#f0f2f5" : "#191c1e",
    boxShadow: theme.mode === "light"
      ? "inset 4px 4px 8px #d1d9e6, inset -4px -4px 8px #ffffff"
      : "inset 4px 4px 8px #0d0e10, inset -4px -4px 8px #25292c",
    transition: "all 0.3s ease",
  },

  messageInputWrapperPrivate: {
    padding: 8,
    marginRight: 7,
    display: "flex",
    borderRadius: 24,
    flex: 1,
    position: "relative",
    zIndex: 10,
    border: "none",
    backgroundColor: theme.mode === "light" ? "#fef08a" : "#451a03",
    boxShadow: theme.mode === "light"
      ? "inset 3px 3px 6px #eab308, inset -3px -3px 6px #fef08a"
      : "inset 3px 3px 6px #1c0d02, inset -3px -3px 6px #451a03",
    transition: "all 0.3s ease",
  },

  messageInputWrapperPending: {
    padding: 8,
    marginRight: 7,
    display: "flex",
    borderRadius: 24,
    flex: 1,
    position: "relative",
    zIndex: 10,
    border: "none",
    backgroundColor: theme.mode === "light" ? "#ffedd5" : "#431407",
    boxShadow: theme.mode === "light"
      ? "inset 3px 3px 6px #f97316, inset -3px -3px 6px #ffedd5"
      : "inset 3px 3px 6px #1a0500, inset -3px -3px 6px #431407",
    transition: "all 0.3s ease",
  },
  messageInput: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
    color: theme.mode === "light" ? "#1f2937" : "#f3f4f6",
  },
  messageInputPrivate: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
    color: theme.mode === "light" ? "#713f12" : "#fef08a",
  },
  messageInputPending: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
    color: theme.mode === "light" ? "#c2410c" : "#fed7aa",
    fontWeight: 500,
  },
  messageInputWrapperAccept: {
    padding: 8,
    marginRight: 7,
    display: "flex",
    borderRadius: 24,
    flex: 1,
    position: "relative",
    zIndex: 10,
    border: "none",
    backgroundColor: theme.mode === "light" ? "#dcfce7" : "#062f17",
    boxShadow: theme.mode === "light"
      ? "inset 3px 3px 6px #22c55e, inset -3px -3px 6px #dcfce7"
      : "inset 3px 3px 6px #021a0a, inset -3px -3px 6px #062f17",
    transition: "all 0.3s ease",
    marginBottom: 8,
  },
  messageInputAccept: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
    color: theme.mode === "light" ? "#15803d" : "#bbf7d0",
    fontWeight: 500,
  },
  modeButtonActive: {
    color: theme.palette.primary.main,
  },
  sendMessageIcons: {
    color: grey[700],
  },
  ForwardMessageIcons: {
    color: grey[700],
    transform: "scaleX(-1)",
  },
  uploadInput: {
    display: "none",
  },
  viewMediaInputWrapper: {
    maxHeight: "100%",
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.mode === "light" ? "#ffffff" : "#232628",
    borderTop: "none",
  },
  emojiBox: {
    position: "absolute",
    bottom: 63,
    width: 40,
    borderTop: "1px solid #e8e8e8",
    zIndex: 1400, // Z-index alto para ficar acima do modal de preview de imagem (z-index 1300)
  },
  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },
  audioLoading: {
    color: green[500],
    opacity: "70%",
  },
  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },
  cancelAudioIcon: {
    color: "red",
  },
  sendAudioIcon: {
    color: "green",
  },
  signatureSwitchButton: {
    padding: 4,
  },
  signatureSwitchTrack: {
    width: 44,
    height: 24,
    borderRadius: 999,
    position: "relative",
    transition: "background-color 0.2s ease",
  },
  signatureSwitchTrackOn: {
    backgroundColor: "#2196F3",
  },
  signatureSwitchTrackOff: {
    backgroundColor: "#ff5a5f",
  },
  signatureSwitchThumb: {
    width: 18,
    height: 18,
    borderRadius: "50%",
    backgroundColor: "#fff",
    position: "absolute",
    top: 3,
    transition: "left 0.2s ease",
  },
  signatureSwitchThumbOn: {
    left: 23,
    backgroundColor: "#ffffff",
  },
  signatureSwitchThumbOff: {
    left: 3,
    backgroundColor: "#fff",
  },
  pendingModeSwitchButton: {
    padding: 4,
  },
  pendingModeSwitchTrack: {
    width: 86,
    height: 24,
    borderRadius: 999,
    position: "relative",
    transition: "background-color 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 8px",
    boxSizing: "border-box",
    color: "#fff",
    fontSize: "0.68rem",
    fontWeight: 600,
    overflow: "hidden",
  },
  pendingModeSwitchTrackNormal: {
    backgroundColor: "#4CAF50",
  },
  pendingModeSwitchTrackInternal: {
    backgroundColor: "#FF9800",
  },
  pendingModeSwitchThumb: {
    width: 18,
    height: 18,
    borderRadius: "50%",
    backgroundColor: "#fff",
    position: "absolute",
    top: 3,
    transition: "left 0.2s ease",
  },
  pendingModeSwitchThumbNormal: {
    left: 3,
  },
  pendingModeSwitchThumbInternal: {
    left: 65,
  },
  pendingModeSwitchLabel: {
    position: "relative",
    zIndex: 1,
    opacity: 0.72,
  },
  pendingModeSwitchLabelActive: {
    opacity: 1,
  },
  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
    backgroundColor: theme.palette.optionsBackground,
  },
  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: theme.mode === "light" ? "#f0f0f0" : "#1d282f",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },
  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },
  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },
  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },
  floatingFormatMenu: {
    position: 'fixed',
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[8],
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '4px',
    border: `1px solid ${theme.palette.divider}`,
  },

  formatIconButton: {
    padding: '6px',
    borderRadius: '4px',
    minWidth: '32px',
    height: '32px',
  },
  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },
  messageQuickAnswersWrapper: {
    margin: 0,
    position: "absolute",
    bottom: "100%", // ✅ Posicionar acima do input
    background: theme.palette.background.default,
    padding: 0,
    border: "none",
    left: 0,
    right: 0, // ✅ Usar right: 0 em vez de width: 100%
    maxHeight: "200px",
    overflowY: "auto",
    overflowX: "hidden",
    boxShadow: "0 -4px 16px rgba(0, 0, 0, 0.15)",
    borderRadius: "8px 8px 0 0",
    zIndex: 1000, // ✅ Z-index menor para evitar conflitos
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: "3px",
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },
    "& li": {
      listStyle: "none",
      "& a": {
        display: "block",
        padding: "8px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        maxHeight: "auto",
        "&:hover": {
          background: theme.palette.background.paper,
          cursor: "pointer",
        },
      },
    },
  },
  quickAnswerItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1.5),
    minHeight: "48px",
    cursor: "pointer", // ✅ Adicionar cursor pointer
    borderRadius: "4px", // ✅ Bordas arredondadas
    margin: "2px 4px", // ✅ Pequena margem
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    transition: "all 0.2s ease-in-out",
  },

  // ✅ NOVO: Estilo para item selecionado via teclado
  quickAnswerItemSelected: {
    backgroundColor: theme.palette.primary.light + "30", // ✅ Cor semi-transparente
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    fontWeight: 500,
  },

  // ✅ NOVO: Indicador de scroll
  quickAnswersScrollIndicator: {
    textAlign: "center",
    padding: theme.spacing(1),
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    fontStyle: "italic",
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  quickAnswerText: {
    flex: 1,
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  mediaTypeChip: {
    height: 20,
    fontSize: "0.7rem",
  },
  invertedFabMenu: {
    border: "none",
    borderRadius: 50,
    boxShadow: "none",
    padding: theme.spacing(1),
    backgroundColor: "transparent",
    color: "grey",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&:disabled": {
      backgroundColor: "transparent !important",
    },
  },
  invertedFabMenuMP: {
    border: "none",
    borderRadius: 0,
    boxShadow: "none",
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: blue[800],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuCont: {
    border: "none",
    borderRadius: 0,
    boxShadow: "none",
    minHeight: "auto",
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: blue[500],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuMeet: {
    border: "none",
    borderRadius: 0,
    boxShadow: "none",
    minHeight: "auto",
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: green[500],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuDoc: {
    border: "none",
    borderRadius: 0,
    boxShadow: "none",
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: "#7f66ff",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuCamera: {
    border: "none",
    borderRadius: 0,
    boxShadow: "none",
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: pink[500],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  flexContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  flexItem: {
    flex: 1,
  },
  pendingAlert: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1, 2),
    backgroundColor: "#E3F2FD",
    border: "1px solid #2196F3",
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    color: "#1976D2",
    fontSize: "0.875rem",
    textAlign: "center",
    width: "fit-content",
    maxWidth: "calc(100% - 16px)",
    alignSelf: "center",
    boxSizing: "border-box",
  },
}));

const MessageInput = ({
  ticketId,
  ticketStatus,
  droppedFiles,
  contactId,
  ticketChannel,
  whatsappId,
  ticket,
  contact,
  draftMode = false,
  draftUuid = null,
  onDraftSent = null,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const emojiMartI18n = getEmojiMartI18n(i18n.resolvedLanguage || i18n.language);
  const emojiTheme = theme?.palette?.type === "light" ? "light" : "dark";
  const [mediasUpload, setMediasUpload] = useState([]);
  const isMounted = useRef(true);

  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [templateModalOpen, setTemplateModalOpen] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [quickAnswers, setQuickAnswer] = useState([]);
  const [typeBar, setTypeBar] = useState(false);
  const inputRef = useRef();
  const isSendingRef = useRef(false);
  const [onDragEnter, setOnDragEnter] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { setReplyingMessage, replyingMessage } =
    useContext(ReplyMessageContext);
  const { setEditingMessage, editingMessage } = useContext(EditMessageContext);
  const { user, socket } = useContext(AuthContext);
  const companyTimezone = resolveCompanyTimezone(user?.company?.timezone || getStoredCompanyTimezone());
  const [appointmentModalOpen, setAppointmentModalOpen] = useState(false);
  const { getPlanCompany } = usePlans();

  const [signMessagePar, setSignMessagePar] = useState(false);
  const { get: getSetting } = useCompanySettings();
  const [signMessage, setSignMessage] = useState(true);
  const [privateMessage, setPrivateMessage] = useState(false);
  const [privateMessageInputVisible, setPrivateMessageInputVisible] =
    useState(false);
  const [senVcardModalOpen, setSenVcardModalOpen] = useState(false);
  const [showModalMedias, setShowModalMedias] = useState(false);
  const [showSchedules, setShowSchedules] = useState(false);
  const [useWhatsappOfficial, setUseWhatsappOfficial] = useState(false);
  const { list: listQuickMessages } = useQuickMessages();

  const isMobile = useMediaQuery("(max-width: 767px)");
  const [placeholderText, setPlaceHolderText] = useState("");

  const [selectedQuickAnswerIndex, setSelectedQuickAnswerIndex] = useState(-1);
  const [isNavigatingQuickAnswers, setIsNavigatingQuickAnswers] = useState(false);

  const [triggerFlowModalOpen, setTriggerFlowModalOpen] = useState(false);
  const [flowProcessing, setFlowProcessing] = useState(false);
  const flowProcessingRef = useRef(false);

  const [formatMenuAnchorPosition, setFormatMenuAnchorPosition] = useState(null);
  const [selectedText, setSelectedText] = useState({ text: '', start: 0, end: 0 });

  // Estados para máscaras dinâmicas
  const [maskAnchorEl, setMaskAnchorEl] = useState(null);
  const [filteredMasks, setFilteredMasks] = useState([]);
  const [cursorPosition, setCursorPosition] = useState(0);

  // Estado para janela de 24h do WhatsApp Oficial
  const [needsTemplate, setNeedsTemplate] = useState(false);
  const [isWhatsAppOfficial, setIsWhatsAppOfficial] = useState(false);
  const [windowCheckLoading, setWindowCheckLoading] = useState(false);
  const [pendingInputMode, setPendingInputMode] = useState("normal");

  const isTicketPending = () => {
    return ticketStatus === "pending";
  };

  useEffect(() => {
    if (isTicketPending()) {
      setPrivateMessage(false);
      setPrivateMessageInputVisible(false);
      setPendingInputMode("normal");
    }
  }, [ticketStatus]);

  useEffect(() => {
    async function fetchTemplates() {
      const templates = await api.request({
        url: `/quick-messages/list`,
        method: "GET",
        params: {
          isOficial: "true",
          userId: user.id,
          companyId: user.companyId,
          status: "APPROVED",
          // whatsappId,
        },
      });
      setTemplates(templates.data);
    }
    if (useWhatsappOfficial) {
      fetchTemplates();
    }
  }, [useWhatsappOfficial]);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);
      setShowSchedules(planConfigs.plan.useSchedules);
      setUseWhatsappOfficial(planConfigs.plan.useWhatsappOfficial);
    }
    fetchData();
  }, []);

  // Função para verificar janela de 24h (reutilizável)
  const checkWhatsAppWindow = useCallback(async () => {
    if (!ticketId || ticketChannel !== "whatsapp_oficial") {
      setNeedsTemplate(false);
      setIsWhatsAppOfficial(false);
      return;
    }

    try {
      setWindowCheckLoading(true);
      const { data } = await api.get(`/tickets/${ticketId}/check-whatsapp-window`);
      
      setIsWhatsAppOfficial(data.isWhatsAppOfficial);
      setNeedsTemplate(data.needsTemplate);
      
      console.log("📱 WhatsApp Window Check:", {
        needsTemplate: data.needsTemplate,
        isWithin24Hours: data.isWithin24Hours,
        hoursElapsed: data.hoursElapsed
      });
    } catch (err) {
      console.error("Erro ao verificar janela de 24h:", err);
      setNeedsTemplate(false);
    } finally {
      setWindowCheckLoading(false);
    }
  }, [ticketId, ticketChannel]);

  // Verificar janela de 24h do WhatsApp Oficial
  useEffect(() => {
    checkWhatsAppWindow();
  }, [checkWhatsAppWindow]);

  // ✅ Re-verificar janela de 24h quando uma nova mensagem do contato chegar
  useEffect(() => {
    if (!ticketId || ticketChannel !== "whatsapp_oficial" || !socket || !user?.companyId) {
      console.log("⚠️ Socket listener não iniciado:", { 
        hasTicketId: !!ticketId, 
        isWhatsAppOficial: ticketChannel === "whatsapp_oficial",
        hasSocket: !!socket,
        hasCompanyId: !!user?.companyId
      });
      return;
    }

    const companyId = user.companyId;
    
    console.log("🎧 Iniciando listener de socket para janela de 24h", {
      ticketId,
      companyId,
      channel: ticketChannel
    });

    const onAppMessage = (data) => {
      console.log("📩 Evento socket recebido:", {
        action: data.action,
        ticketUuid: data.message?.ticket?.uuid,
        ticketId: data.message?.ticket?.id,
        currentTicketId: ticketId,
        fromMe: data.message?.fromMe,
        messageId: data.message?.id
      });

      // ✅ Quando uma nova mensagem é criada E não é do usuário (é do contato)
      // Verificar tanto por UUID quanto por ID numérico para garantir compatibilidade
      const eventTicketIds = [
        data.message?.ticket?.uuid,
        data.message?.ticket?.id,
        data.message?.ticketId,
        data.ticket?.uuid,
        data.ticket?.id
      ].filter((value) => value !== undefined && value !== null);
      const isThisTicket = eventTicketIds.some((value) => String(value) === String(ticketId));

      if (data.action === "create" && isThisTicket && !data.message?.fromMe) {
        console.log("✅ Nova mensagem do contato detectada - Re-verificando janela de 24h");
        // Aguardar um pouco para garantir que o backend atualizou lastInteractionClient
        setTimeout(() => {
          checkWhatsAppWindow();
        }, 1000);
      }
    };

    socket.on(`company-${companyId}-appMessage`, onAppMessage);

    return () => {
      console.log("🔌 Removendo listener de socket");
      socket.off(`company-${companyId}-appMessage`, onAppMessage);
    };
  }, [ticketId, ticketChannel, socket, user?.companyId, checkWhatsAppWindow]);

  useEffect(() => {
    if (needsTemplate && isWhatsAppOfficial) {
      setPlaceHolderText("⚠️ Janela de 24h expirada - Envie um template primeiro");
    } else if (ticketStatus === "open" || ticketStatus === "group") {
      setPlaceHolderText(i18n.t("messagesInput.placeholderOpen"));
    } else if (ticketStatus === "pending") {
      setPlaceHolderText(i18n.t("messagesInput.placeholderOpen"));
    } else {
      setPlaceHolderText(i18n.t("messagesInput.placeholderClosed"));
    }

    const maxLength = isMobile ? 20 : Infinity;

    if (isMobile && placeholderText.length > maxLength) {
      setPlaceHolderText(placeholderText.substring(0, maxLength) + "...");
    }
  }, [ticketStatus, needsTemplate, isWhatsAppOfficial]);

  const {
    selectedMessages,
    setForwardMessageModalOpen,
    showSelectMessageCheckbox,
    forwardMessageModalOpen,
    cancelForwardMode,
  } = useContext(ForwardMessageContext);

  // ✅ ESC para cancelar modo encaminhar
  useEffect(() => {
    if (!showSelectMessageCheckbox) return;

    const handleKeyDown = (e) => {
      // Não cancelar se houver modal aberto (o modal tratará seu próprio ESC)
      // forwardMessageModalOpen já está disponível do contexto desestruturado acima
      if (e.key === "Escape" && !forwardMessageModalOpen) {
        e.preventDefault();
        e.stopPropagation();
        cancelForwardMode();
      }
    };

    // Usar capture:true para garantir prioridade
    window.addEventListener("keydown", handleKeyDown, { capture: true });
    
    return () => {
      window.removeEventListener("keydown", handleKeyDown, { capture: true });
    };
  }, [showSelectMessageCheckbox, forwardMessageModalOpen, cancelForwardMode]);

  useEffect(() => {
    if (droppedFiles && droppedFiles.length > 0) {
      const selectedMedias = Array.from(droppedFiles);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  }, [droppedFiles]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    inputRef.current.focus();
    if (editingMessage) {
      setInputMessage(editingMessage.body);
    }
  }, [replyingMessage, editingMessage]);

  useEffect(() => {
    inputRef.current.focus();
    return () => {
      setInputMessage("");
      setShowEmoji(false);
      setMediasUpload([]);
      setReplyingMessage(null);
      if (!isTicketPending()) {
        setPrivateMessage(false);
        setPrivateMessageInputVisible(false);
      }
      setEditingMessage(null);
    };
  }, [ticketId, setReplyingMessage, setEditingMessage]);


  useEffect(() => {
    let isProcessing = false; // ✅ Flag para evitar processamento duplo

    const handleInsertQuickMessage = (event) => {
      // ✅ IMPORTANTE: Evitar processamento duplo
      if (isProcessing) {
        console.log("⚠️ Já processando evento, ignorando...");
        return;
      }

      isProcessing = true;
      console.log("📥 Evento insertQuickMessage recebido:", event.detail);

      const { quickMessage } = event.detail;

      if (!quickMessage) {
        console.error("❌ quickMessage não encontrado no evento");
        isProcessing = false;
        return;
      }

      console.log("🔍 Processando quickMessage:", {
        hasMedia: !!quickMessage.mediaPath,
        mediaType: quickMessage.mediaType,
        message: quickMessage.message,
        ticketId: ticketId
      });

      if (quickMessage.mediaPath) {
        console.log("🎵 Processando resposta rápida com mídia");
        handleQuickAnswersClick({
          value: quickMessage.message || "",
          mediaPath: quickMessage.mediaPath,
          mediaType: quickMessage.mediaType,
          shortcode: quickMessage.shortcode,
          label: `/${quickMessage.shortcode} - ${quickMessage.message}`
        }).finally(() => {
          isProcessing = false; // ✅ Liberar flag após processamento
        });
      } else {
        console.log("📝 Processando resposta rápida de texto");
        const currentText = inputMessage?.trim() || "";
        const newText = currentText
          ? `${currentText}\n\n${quickMessage.message}`
          : quickMessage.message;

        setInputMessage(newText);

        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
            const length = newText.length;
            inputRef.current.setSelectionRange(length, length);
          }
          isProcessing = false; // ✅ Liberar flag
        }, 100);
      }
    };

    // ✅ IMPORTANTE: Escutar apenas no window
    window.addEventListener('insertQuickMessage', handleInsertQuickMessage);

    return () => {
      window.removeEventListener('insertQuickMessage', handleInsertQuickMessage);
      isProcessing = false; // ✅ Reset da flag no cleanup
    };
  }, [inputMessage, ticketId, privateMessage]);

  useEffect(() => {
    setTimeout(() => {
      if (isMounted.current) setOnDragEnter(false);
    }, 1000);
  }, [onDragEnter === true]);

  useEffect(() => {
    const fetchSettings = async () => {
      const setting = await getSetting({
        column: "sendSignMessage",
      });

      if (isMounted.current) {
        if (setting.sendSignMessage === "enabled") {
          setSignMessagePar(true);
          const signMessageStorage = JSON.parse(
            localStorage.getItem("persistentSignMessage")
          );
          if (isNil(signMessageStorage)) {
            setSignMessage(true);
          } else {
            setSignMessage(signMessageStorage);
          }
        } else if (setting.sendSignMessage === "dontSend") {
          localStorage.setItem("persistentSignMessage", false);
          setSignMessage(false);
          setSignMessagePar(false);
        } else {
          setSignMessagePar(false);
        }
      }
    };
    fetchSettings();
  }, []);

  // CORREÇÃO DO ERRO charAt - Função mais robusta
  const safeCapitalizeFirstLetter = (string) => {
    if (!string || typeof string !== 'string') return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  // FUNÇÕES PARA TRIGGER FLOW MODAL
  const handleTriggerFlowClick = useCallback(() => {
    console.log("🎯 Abrindo modal de fluxo");

    // 🛡️ RESET PREVENTIVO
    setFlowProcessing(false);
    flowProcessingRef.current = false;

    setTriggerFlowModalOpen(true);
  }, []);

  const handleTriggerFlowClose = useCallback(() => {
    console.log("🚪 Fechando modal");

    setFlowProcessing(false);
    flowProcessingRef.current = false;
    setTriggerFlowModalOpen(false);
  }, []);

  const handleFlowProcessing = useCallback((isProcessing) => {
    console.log("🔄 Flow processing:", isProcessing);
    setFlowProcessing(isProcessing);
    flowProcessingRef.current = isProcessing;

    // 🔥 TIMEOUT SIMPLES: 8 segundos e libera SEM PERGUNTAR
    if (isProcessing) {
      setTimeout(() => {
        console.log("⏰ TIMEOUT - Liberando campo FORÇADO");
        setFlowProcessing(false);
        flowProcessingRef.current = false;
      }, 8000);
    }
  }, []);

  const handleFlowTriggered = useCallback((data) => {
    console.log("✅ Fluxo concluído");

    // 🔥 RESET IMEDIATO - SEM TIMEOUT
    setFlowProcessing(false);
    flowProcessingRef.current = false;
  }, []);

  // ✅ PASSO 3: Map de labels do status conforme definição real do sistema
  const TICKET_STATUS_LABEL = useMemo(() => ({
    open: i18n.t("tickets.search.filterConectionsOptions.open") || "Aberto",
    closed: i18n.t("tickets.search.filterConectionsOptions.closed") || "Fechado",
    pending: i18n.t("tickets.search.filterConectionsOptions.pending") || "Pendente",
    group: "Grupo",
  }), []);

  // ✅ PASSO 2: Criar resolvedor de variáveis (map de tokens -> valor real)
  // Função auxiliar para obter primeiro nome
  const getFirstName = (fullName) => {
    if (!fullName) return "";
    const nameArr = fullName.split(" ");
    return nameArr[0] || "";
  };

  // Função auxiliar para obter saudação baseada na hora
  const getGreeting = () => {
    const localNow = moment().tz(companyTimezone);
    const hh = localNow.hours();
    if (hh >= 6 && hh <= 11) return "Bom dia";
    if (hh > 11 && hh <= 17) return "Boa tarde";
    if (hh > 17 && hh <= 23) return "Boa noite";
    return "Boa madrugada";
  };

  // Função auxiliar para formatar data (dd-mm-yyyy)
  const getFormattedDate = (date = null) => {
    const localDate = date ? moment(date).tz(companyTimezone) : moment().tz(companyTimezone);
    return localDate.format("DD-MM-YYYY");
  };

  // Função auxiliar para formatar hora (hh:mm:ss)
  const getFormattedHour = () => {
    return moment().tz(companyTimezone).format("HH:mm:ss");
  };

  // Função auxiliar para gerar protocolo (data/hora + ticket.id)
  const getProtocol = (ticketId) => {
    const localNow = moment().tz(companyTimezone);
    const dd = localNow.format("DD");
    const mm = localNow.format("MM");
    const yyyy = localNow.format("YYYY");
    const min = localNow.format("mm");
    const sec = localNow.format("ss");
    const ms = localNow.format("SSS");
    const control = `${yyyy}${mm}${dd}${min}${sec}${ms}`;
    const ticketNum = ticketId ? String(ticketId) : "";
    return control + ticketNum;
  };

  const resolveMentionValue = useCallback((token, ctx) => {
    if (!ctx) return token; // Fallback se não houver contexto

    switch (token) {
      case "${contact.firstName}":
        return getFirstName(ctx.contact?.name ?? "");
      
      case "${contact.name}":
        return ctx.contact?.name ?? "";
      
      case "${contact.number}":
        return ctx.contact?.number ?? "";
      
      case "${user.name}":
        return ctx.ticket?.user?.name ?? ctx.user?.name ?? "";
      
      case "${greeting}":
        return getGreeting();
      
      case "${protocol}":
        const ticketIdForProtocol = ctx.ticket?.id ?? ticketId ?? "";
        return getProtocol(ticketIdForProtocol);
      
      case "${date}":
        return getFormattedDate();
      
      case "${hour}":
        return getFormattedHour();
      
      case "${ticket.number}":
        return String(ctx.ticket?.id ?? ctx.ticket?.uuid ?? ticketId ?? "");
      
      case "${ticket.status}":
        // Resolver status do ticket para label humano
        const status = ctx.ticket?.status || ticketStatus;
        return TICKET_STATUS_LABEL[status] || status || token;
      
      case "${queue.name}":
        return ctx.ticket?.queue?.name ?? "";
      
      case "${connection}":
        return ctx.ticket?.whatsapp?.name ?? ctx.ticket?.channel ?? "";
      
      case "${company.name}":
        return ctx.ticket?.company?.name ?? ctx.user?.company?.name ?? "";
      
      case "${scheduleDate}":
        // Data do agendamento - se houver schedule no contexto
        if (ctx.schedule?.sendAt) {
          const scheduleDate = new Date(ctx.schedule.sendAt);
          return getFormattedDate(scheduleDate);
        }
        return getFormattedDate(); // Fallback para data atual
      
      default:
        return token; // Fallback para não quebrar
    }
  }, [ticketStatus, ticketId, user, TICKET_STATUS_LABEL]);

  // NAVEGAÇÃO POR TECLADO CORRIGIDA
  const handleMaskSelect = useCallback((mask) => {
    if (!inputRef.current) return;

    const currentValue = inputMessage || "";
    const textBeforeCursor = currentValue.substring(0, cursorPosition);
    const textAfterCursor = currentValue.substring(cursorPosition);
    
    // Encontrar a última ocorrência de "@" antes do cursor
    const lastAtIndex = textBeforeCursor.lastIndexOf("@");
    
    if (lastAtIndex !== -1) {
      // ✅ INSERIR O CÓDIGO {{variavel}} (não o valor resolvido)
      const newText = 
        currentValue.substring(0, lastAtIndex) + 
        mask.code + 
        " " + // Adiciona espaço após a variável
        textAfterCursor;
      
      setInputMessage(newText);
      
      // Fechar o menu
      setMaskAnchorEl(null);
      setFilteredMasks([]);
      
      // Focar no input e posicionar o cursor após a máscara
      setTimeout(() => {
        if (inputRef.current) {
          const newCursorPos = lastAtIndex + mask.code.length + 1;
          inputRef.current.setSelectionRange(newCursorPos, newCursorPos);
          inputRef.current.focus();
        }
      }, 0);
    }
  }, [inputMessage, cursorPosition]);

  const handleKeyDown = useCallback((e) => {
    // Verificar se há menu de máscaras aberto
    if (maskAnchorEl && filteredMasks.length > 0) {
      if (e.key === "Escape") {
        setMaskAnchorEl(null);
        setFilteredMasks([]);
        return;
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        // Implementar navegação com setas (opcional)
        return;
      } else if (e.key === "Enter" && filteredMasks.length === 1) {
        e.preventDefault();
        handleMaskSelect(filteredMasks[0]);
        return;
      }
    }

    if (!typeBar || !Array.isArray(typeBar) || typeBar.length === 0) {
      setSelectedQuickAnswerIndex(-1);
      setIsNavigatingQuickAnswers(false);
      return;
    }

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setIsNavigatingQuickAnswers(true);
        setSelectedQuickAnswerIndex(prev => {
          const nextIndex = prev < typeBar.length - 1 ? prev + 1 : 0;

          // SCROLL AUTOMÁTICO CORRIGIDO
          setTimeout(() => {
            const container = document.querySelector('.MuiBox-root ul');
            if (container) {
              const selectedElement = container.children[nextIndex];
              if (selectedElement) {
                selectedElement.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest'
                });
              }
            }
          }, 0);

          return nextIndex;
        });
        break;

      case 'ArrowUp':
        e.preventDefault();
        setIsNavigatingQuickAnswers(true);
        setSelectedQuickAnswerIndex(prev => {
          const nextIndex = prev > 0 ? prev - 1 : typeBar.length - 1;

          // SCROLL AUTOMÁTICO CORRIGIDO
          setTimeout(() => {
            const container = document.querySelector('.MuiBox-root ul');
            if (container) {
              const selectedElement = container.children[nextIndex];
              if (selectedElement) {
                selectedElement.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest'
                });
              }
            }
          }, 0);

          return nextIndex;
        });
        break;

      case 'Enter':
        if (isNavigatingQuickAnswers && selectedQuickAnswerIndex >= 0) {
          e.preventDefault();
          const selectedAnswer = typeBar[selectedQuickAnswerIndex];
          handleQuickAnswersClick(selectedAnswer);
          setSelectedQuickAnswerIndex(-1);
          setIsNavigatingQuickAnswers(false);
        }
        break;

      case 'Escape':
        if (isNavigatingQuickAnswers) {
          e.preventDefault();
          setSelectedQuickAnswerIndex(-1);
          setIsNavigatingQuickAnswers(false);
          setTypeBar(false);
        }
        break;

      case 'Tab':
        if (isNavigatingQuickAnswers) {
          e.preventDefault();
          setSelectedQuickAnswerIndex(prev => {
            const nextIndex = prev < typeBar.length - 1 ? prev + 1 : 0;
            return nextIndex;
          });
        }
        break;

      default:
        if (isNavigatingQuickAnswers && e.key.length === 1) {
          setSelectedQuickAnswerIndex(-1);
          setIsNavigatingQuickAnswers(false);
        }
        break;
    }
  }, [
    typeBar,
    selectedQuickAnswerIndex,
    isNavigatingQuickAnswers,
    maskAnchorEl,
    filteredMasks,
    handleMaskSelect
  ]);

  useEffect(() => {
    if (!typeBar || !Array.isArray(typeBar) || typeBar.length === 0) {
      setSelectedQuickAnswerIndex(-1);
      setIsNavigatingQuickAnswers(false);
    }
  }, [typeBar]);

  const getQuickAnswerItemStyle = (index) => ({
    backgroundColor: selectedQuickAnswerIndex === index
      ? (theme.mode === 'light' ? '#e3f2fd' : '#1e3a5f')
      : 'transparent',
    borderLeft: selectedQuickAnswerIndex === index
      ? `4px solid ${theme.palette.primary.main}`
      : '4px solid transparent',
  });

  const handleSendLinkVideo = async () => {
    const link = `https://meet.jit.si/${ticketId}`;
    setInputMessage(link);
  };

  const handleSendTemplate = async () => {
    setTemplateModalOpen(true);
  };

  // ✅ PADRONIZADO: Todas as máscaras agora usam {{variavel}}
  const AVAILABLE_MASKS = useMemo(() => [
    // === CONTATO ===
    { code: "{{firstName}}", description: "Primeiro Nome", category: "Contato" },
    { code: "{{name}}", description: "Nome Completo", category: "Contato" },
    { code: "{{contactNumber}}", description: "Número do Contato", category: "Contato" },
    { code: "{{contactEmail}}", description: "Email do Contato", category: "Contato" },
    
    // === TICKET ===
    { code: "{{ticket_id}}", description: "ID do Ticket", category: "Ticket" },
    { code: "{{ticketUuid}}", description: "UUID do Ticket", category: "Ticket" },
    { code: "{{ticketStatus}}", description: "Status do Ticket", category: "Ticket" },
    { code: "{{ticketDate}}", description: "Data de Criação do Ticket", category: "Ticket" },
    { code: "{{ticketTime}}", description: "Hora de Criação do Ticket", category: "Ticket" },
    { code: "{{ticketDateTime}}", description: "Data e Hora de Criação", category: "Ticket" },
    
    // === USUÁRIO/ATENDENTE ===
    { code: "{{userName}}", description: "Nome do Atendente", category: "Usuário" },
    { code: "{{userId}}", description: "ID do Atendente", category: "Usuário" },
    { code: "{{userEmail}}", description: "Email do Atendente", category: "Usuário" },
    
    // === FILA/SETOR ===
    { code: "{{queue}}", description: "Nome da Fila", category: "Fila" },
    { code: "{{queueId}}", description: "ID da Fila", category: "Fila" },
    { code: "{{position}}", description: "Posição na Fila", category: "Fila" },
    
    // === CONEXÃO ===
    { code: "{{connection}}", description: "Nome da Conexão", category: "Conexão" },
    { code: "{{connectionId}}", description: "ID da Conexão", category: "Conexão" },
    { code: "{{connectionNumber}}", description: "Número da Conexão", category: "Conexão" },
    
    // === EMPRESA ===
    { code: "{{name_company}}", description: "Nome da Empresa", category: "Empresa" },
    { code: "{{companyId}}", description: "ID da Empresa", category: "Empresa" },
    { code: "{{companyPhone}}", description: "Telefone da Empresa", category: "Empresa" },
    { code: "{{companyEmail}}", description: "Email da Empresa", category: "Empresa" },
    
    // === SISTEMA ===
    { code: "{{ms}}", description: "Saudação", category: "Sistema" },
    { code: "{{protocol}}", description: "Protocolo", category: "Sistema" },
    { code: "{{date}}", description: "Data Atual", category: "Sistema" },
    { code: "{{hour}}", description: "Hora Atual", category: "Sistema" },
    { code: "{{data_hora}}", description: "Data e Hora Atual", category: "Sistema" },
    
    // === AGENDAMENTO ===
    { code: "{{dataAgendamento}}", description: "Data do Agendamento", category: "Agendamento" },
  ], []);

  const handleChangeInput = useCallback((e) => {
    const newValue = e.target.value;
    let cursorPos = e.target.selectionStart;
    
    // Garantir que cursorPos seja um número válido
    if (cursorPos === null || cursorPos === undefined || isNaN(cursorPos)) {
      cursorPos = newValue.length;
    }
    
    setInputMessage(newValue);
    setCursorPosition(cursorPos);

    // Verificar se o usuário digitou "@" para abrir o menu de máscaras
    const textBeforeCursor = newValue.substring(0, cursorPos);
    const lastAtIndex = textBeforeCursor.lastIndexOf("@");
    
    // Verificar se há um espaço ou quebra de linha após o "@" (se sim, não mostrar menu)
    if (lastAtIndex !== -1) {
      const textAfterAt = textBeforeCursor.substring(lastAtIndex + 1);
      const hasSpaceAfterAt = textAfterAt.includes(" ") || textAfterAt.includes("\n");
      
      if (!hasSpaceAfterAt) {
        const searchTerm = textAfterAt.toLowerCase();
        
        // Filtrar máscaras baseado no termo de busca
        const filtered = AVAILABLE_MASKS.filter(mask => 
          mask.code.toLowerCase().includes(searchTerm) || 
          mask.description.toLowerCase().includes(searchTerm) ||
          mask.category.toLowerCase().includes(searchTerm)
        );
        
        setFilteredMasks(filtered);
        
        // Posicionar o Popper próximo ao cursor - usar setTimeout para garantir que o DOM está atualizado
        setTimeout(() => {
          if (inputRef.current) {
            setMaskAnchorEl(inputRef.current);
          }
        }, 0);
      } else {
        setMaskAnchorEl(null);
        setFilteredMasks([]);
      }
    } else {
      setMaskAnchorEl(null);
      setFilteredMasks([]);
    }
  }, [AVAILABLE_MASKS]);

  const handlePrivateMessage = (e) => {
    if (isTicketPending()) {
      return;
    }
    setPrivateMessage(!privateMessage);
    setPrivateMessageInputVisible(!privateMessageInputVisible);
  };

  const getMediaTypeIcon = (mediaType) => {
    switch (mediaType) {
      case 'audio': return '🎵';
      case 'image': return '🖼️';
      case 'video': return '🎥';
      case 'document': return '📎';
      default: return '📎';
    }
  };

  const getMediaTypeColor = (mediaType) => {
    switch (mediaType) {
      case 'audio': return 'secondary';
      case 'image': return 'primary';
      case 'video': return 'default';
      case 'document': return 'default';
      default: return 'default';
    }
  };

  const handleQuickAnswersClick = useCallback(async (value) => {
    // ✅ IMPORTANTE: Evitar múltiplas execuções simultâneas
    if (loading) {
      console.log("⚠️ Já processando, ignorando clique...");
      return;
    }

    console.log("🎯 handleQuickAnswersClick chamado:", value);
    console.log("📋 ticketId atual:", ticketId);

    if (!ticketId) {
      console.error("❌ ticketId não encontrado");
      toastError("Erro: ID do ticket não encontrado");
      return;
    }

    if (value.mediaPath) {
      try {
        setLoading(true);
        console.log("📥 Baixando mídia:", value.mediaPath);

        const response = await api.get(value.mediaPath, {
          responseType: "blob",
        });

        console.log("✅ Mídia baixada com sucesso, tamanho:", response.data.size);

        const messageBody = value.value && value.value.trim() !== "" ? value.value : "";

        await handleUploadQuickMessageMedia(response.data, messageBody, value.mediaType);

        console.log("✅ Mídia enviada com sucesso");

        setInputMessage("");
        setTypeBar(false);
        return;
      } catch (err) {
        console.error("❌ Erro ao processar mídia:", err);
        toastError(err);
      } finally {
        setLoading(false);
      }
    } else {
      // Para mensagens de texto
      setInputMessage(value.value || "");
      setTypeBar(false);
    }
  }, [loading, ticketId, privateMessage]);

  const handleUploadQuickMessageMedia = useCallback(async (blob, message, mediaType = null) => {
    console.log("📤 Iniciando upload de mídia:", {
      blobSize: blob.size,
      message,
      mediaType,
      ticketId
    });

    if (!ticketId) {
      throw new Error("ID do ticket não encontrado");
    }

    // ✅ IMPORTANTE: Verificar se já está enviando
    if (loading) {
      console.log("⚠️ Upload já em andamento, ignorando...");
      return;
    }

    try {
      let extension = 'bin';

      if (blob.type) {
        const mimeType = blob.type.split("/")[1];
        extension = mimeType;

        if (blob.type.includes('webm') || blob.type.includes('audio')) {
          extension = blob.type.includes('webm') ? 'webm' : 'mp3';
        }
      } else if (mediaType) {
        const typeExtensionMap = {
          'audio': 'webm',
          'image': 'jpg',
          'video': 'mp4',
          'document': 'pdf'
        };
        extension = typeExtensionMap[mediaType] || 'bin';
      }

      const formData = new FormData();
      const filename = `${new Date().getTime()}.${extension}`;
      formData.append("medias", blob, filename);
      formData.append("typeArch", "quickMessage");

      const body = message && message.trim() !== ""
        ? ((privateMessage || isTicketPending()) ? `\u200d${message}` : message)
        : ((privateMessage || isTicketPending()) ? `\u200d` : "");

      formData.append("body", body);
      formData.append("fromMe", true);
      formData.append("isPrivate", (privateMessage || isTicketPending()) ? "true" : "false");

      console.log("📤 Enviando para:", `/messages/${ticketId}`);

      if (isMounted.current) {
        const response = await api.post(`/messages/${ticketId}`, formData);
        console.log("✅ Upload realizado com sucesso:", response.status);
      }
    } catch (err) {
      console.error("❌ Erro no upload:", err);
      // ✅ Não mostrar toastError se for erro de janela de 24h
      const errorMessage = err?.response?.data?.error || err?.message || "";
      if (!errorMessage.includes("Janela de 24h")) {
        toastError(err);
      }
      throw err;
    }
  }, [ticketId, privateMessage, loading]);

  const handleAddEmoji = (e) => {
    let emoji = e.native;
    setInputMessage((prevState) => prevState + emoji);
  };

  const [modalCameraOpen, setModalCameraOpen] = useState(false);

  const handleCapture = (imageData) => {
    if (imageData) {
      handleUploadCamera(imageData);
    }
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }
    const selectedMedias = Array.from(e.target.files);
    setMediasUpload(selectedMedias);
    setShowModalMedias(true);
  };

  const handleChangeSign = (e) => {
    getStatusSingMessageLocalstogare();
  };

  const handleOpenModalForward = () => {
    if (selectedMessages.length === 0) {
      setForwardMessageModalOpen(false);
      toastError(i18n.t("messagesList.header.notMessage"));
      return;
    }
    setForwardMessageModalOpen(true);
  };

  const getStatusSingMessageLocalstogare = () => {
    const signMessageStorage = JSON.parse(
      localStorage.getItem("persistentSignMessage")
    );
    if (signMessageStorage !== null) {
      if (signMessageStorage) {
        localStorage.setItem("persistentSignMessage", false);
        setSignMessage(false);
      } else {
        localStorage.setItem("persistentSignMessage", true);
        setSignMessage(true);
      }
    } else {
      localStorage.setItem("persistentSignMessage", false);
      setSignMessage(false);
    }
  };

  const handleInputPaste = (e) => {
    if (e.clipboardData.files[0]) {
      const selectedMedias = Array.from(e.clipboardData.files);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  };

  const handleInputDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOnDragEnter(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const selectedMedias = Array.from(e.dataTransfer.files);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.types.includes('Files')) {
      setOnDragEnter(true);
    }
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Só remove o highlight se realmente sair do elemento
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setOnDragEnter(false);
    }
  };

  const handleUploadMedia = async (mediasUpload) => {
    setLoading(true);

    if (!mediasUpload.length) {
      console.log("Nenhuma mídia selecionada.");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("fromMe", true);
    formData.append("isPrivate", (privateMessage || isTicketPending()) ? "true" : "false");
    mediasUpload.forEach((media) => {
      formData.append("body", media.caption);
      formData.append("medias", media.file);
    });

    try {
      const response = await api.post(`/messages/${ticketId}`, formData);
      
      // ✅ Verificar se houve resposta parcial (status 207 = Multi-Status)
      if (response.status === 207 && response.data) {
        const { successCount, errorCount, totalCount, errors } = response.data;
        
        if (errorCount > 0) {
          // ✅ Alguns arquivos foram enviados, mas outros falharam
          const errorMessage = `Enviados: ${successCount}/${totalCount}. Erros: ${errorCount}`;
          showErrorToast(errorMessage);
          console.error("Erros detalhados:", errors);
          
          // ✅ Manter apenas os arquivos que falharam para nova tentativa
          // Por enquanto, vamos limpar tudo e mostrar o erro
          // TODO: Implementar lógica para manter apenas arquivos com erro
          setLoading(false);
          setMediasUpload([]);
          setShowModalMedias(false);
        } else {
          // ✅ Todos os arquivos foram enviados com sucesso
          setLoading(false);
          setMediasUpload([]);
          setShowModalMedias(false);
        }
      } else {
        // ✅ Envio bem-sucedido (status 200)
        setLoading(false);
        setMediasUpload([]);
        setShowModalMedias(false);
      }
      
      if (!isTicketPending()) {
        setPrivateMessage(false);
        setPrivateMessageInputVisible(false);
      }
      
      // ✅ Restaurar foco no input após envio
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 100);
    } catch (err) {
      // ✅ Não mostrar toastError se for erro de janela de 24h
      const errorMessage = err?.response?.data?.error || err?.message || "";
      if (!errorMessage.includes("Janela de 24h")) {
        toastError(err);
      }
      setLoading(false);
      // ✅ Em caso de erro, manter os arquivos para tentar novamente
      // O modal continuará aberto para permitir nova tentativa
      // Não limpar mediasUpload nem showModalMedias em caso de erro
    }
  };

  const handleSendContatcMessage = async (vcard) => {
    setSenVcardModalOpen(false);
    setLoading(true);

    if (isNil(vcard)) {
      setLoading(false);
      return;
    }

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: null,
      quotedMsg: replyingMessage,
      isPrivate: (privateMessage || isTicketPending()) ? "true" : "false",
      vCard: vcard,
    };
    try {
      await api.post(`/messages/${ticketId}`, message);
      
      // ✅ Limpar campos apenas se envio foi bem sucedido
      setInputMessage("");
      setShowEmoji(false);
      setLoading(false);
      setReplyingMessage(null);
      setEditingMessage(null);
      if (!isTicketPending()) {
        setPrivateMessage(false);
        setPrivateMessageInputVisible(false);
      }
    } catch (err) {
      // ✅ Não mostrar toastError se for erro de janela de 24h
      const errorMessage = err?.response?.data?.error || err?.message || "";
      if (!errorMessage.includes("Janela de 24h")) {
        toastError(err);
      }
      setLoading(false);
    }
  };

  const handleSendMessage = async () => {
    if (isSendingRef.current || loading) return;
    if (!inputMessage || inputMessage.trim() === "") return;
    
    // ✅ VALIDAÇÃO: Impedir envio se precisa de template
    if (needsTemplate && isWhatsAppOfficial && !isTicketPending()) {
      toastError("Janela de 24h expirada! Envie um template Meta primeiro para retomar a conversa.");
      return;
    }

    isSendingRef.current = true;
    setLoading(true);
    const userName = (privateMessage || isTicketPending())
      ? `${user.name} - Mensagem Interna`
      : user.name;

    const sendMessage = inputMessage.trim();

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body:
        ((signMessage && !isTicketPending()) || privateMessage || isTicketPending()) && !editingMessage
          ? `*${userName}:*\n${sendMessage}`
          : sendMessage,
      quotedMsg: replyingMessage,
      isPrivate: (privateMessage || isTicketPending()) ? "true" : "false",
    };

    try {
      if (editingMessage !== null) {
        await api.post(`/messages/edit/${editingMessage.id}`, message);
      } else if (draftMode && draftUuid) {
        const { data } = await api.post("/contacts/quick-message", {
          draftUuid,
          body: message.body
        });
        if (typeof onDraftSent === "function") {
          onDraftSent(data?.ticket);
        }
      } else {
        console.log("ENVIOU PARA TIKCET", ticketId);
        await api.post(`/messages/${ticketId}`, message);
      }
      
      // ✅ Limpar campos apenas se envio foi bem sucedido
      setInputMessage("");
      setShowEmoji(false);
      setLoading(false);
      setReplyingMessage(null);
      if (!isTicketPending()) {
        setPrivateMessage(false);
      }
      setEditingMessage(null);
      if (!isTicketPending()) {
        setPrivateMessageInputVisible(false);
      }
      handleMenuItemClick();
    } catch (err) {
      // ✅ Não mostrar toastError se for erro de janela de 24h
      // O usuário já vê o alerta visual
      const errorMessage = err?.response?.data?.error || err?.message || "";
      if (!errorMessage.includes("Janela de 24h")) {
        toastError(err);
      }
      setLoading(false);
    } finally {
      isSendingRef.current = false;
    }
  };

  const handleAcceptAndSendMessage = async () => {
    if (isSendingRef.current || loading) return;
    if (!inputMessage || inputMessage.trim() === "") return;
    if (!isTicketPending()) return;

    isSendingRef.current = true;
    setLoading(true);

    try {
      await api.put(`/tickets/${ticketId}`, {
        status:
          ticket?.isGroup && ticket?.channel === "whatsapp" ? "group" : "open",
        userId: user?.id || null,
      });

      const message = {
        read: 1,
        fromMe: true,
        mediaUrl: "",
        body: signMessage
          ? `*${user.name}:*\n${inputMessage.trim()}`
          : inputMessage.trim(),
        quotedMsg: null,
        isPrivate: "false",
      };

      await api.post(`/messages/${ticketId}`, message);
      setInputMessage("");
      setPrivateMessage(false);
      setPrivateMessageInputVisible(false);
      handleMenuItemClick();
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
      isSendingRef.current = false;
    }
  };

  const handleSendPendingInternalMessage = async () => {
    if (isSendingRef.current || loading) return;
    if (!inputMessage || inputMessage.trim() === "") return;
    if (!isTicketPending()) return;

    isSendingRef.current = true;
    setLoading(true);
    try {
      const internalBody = `*${user.name} - Mensagem Interna:*\n${inputMessage.trim()}`;
      await api.post(`/messages/${ticketId}`, {
        read: 1,
        fromMe: true,
        mediaUrl: "",
        body: internalBody,
        quotedMsg: null,
        isPrivate: "true",
      });
      setInputMessage("");
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
      isSendingRef.current = false;
    }
  };

  const handleCreatePendingNote = async () => {
    if (isSendingRef.current || loading) return;
    if (!inputMessage || inputMessage.trim() === "") return;
    if (!isTicketPending()) return;

    isSendingRef.current = true;
    setLoading(true);
    try {
      await api.post("/ticket-notes", {
        note: inputMessage.trim(),
        ticketId,
        contactId,
      });
      setInputMessage("");
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
      isSendingRef.current = false;
    }
  };

  const handleSendPendingByMode = async () => {
    if (pendingInputMode === "internal") {
      await handleSendPendingInternalMessage();
      return;
    }
    if (pendingInputMode === "note") {
      await handleCreatePendingNote();
      return;
    }
    await handleAcceptAndSendMessage();
  };

  const handleSendMessageTemplate = async (e) => {
    if (e.id === "") return;
    setLoading(true);

    const message = {
      templateId: e.id,
      variables: e.variables,
      bodyToSave: e.bodyToSave,
      mediaUrl: "",
      quotedMsg: replyingMessage,
    };

    try {
      await api.post(`/messages-template/${ticketId}`, message);
      
      // ✅ A janela de 24h só abre quando o contato RESPONDE ao template
      // Não resetar needsTemplate aqui - será atualizado quando receber resposta em ReceivedWhatsApp.ts
      console.log("✅ Template enviado - Aguardando resposta do contato para abrir janela de 24h");
      
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
    setTemplateModalOpen(false);
    setInputMessage("");
    setShowEmoji(false);
    setReplyingMessage(null);
    if (!isTicketPending()) {
      setPrivateMessage(false);
    }
    setEditingMessage(null);
    if (!isTicketPending()) {
      setPrivateMessageInputVisible(false);
    }
    handleMenuItemClick();
  };

  const handleStartRecording = async () => {
    setLoading(true);
    try {
      // ✅ Verificar se o navegador suporta getUserMedia
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        showErrorToast("Seu navegador não suporta gravação de áudio. Por favor, use um navegador mais recente.", {
          autoClose: 5000,
          toastId: "browser-not-supported", // ID único para evitar duplicatas
        });
        setLoading(false);
        return;
      }

      // ✅ Verificar se há dispositivos de áudio disponíveis
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const audioInputs = devices.filter(device => device.kind === 'audioinput');
        
        if (audioInputs.length === 0) {
          showErrorToast("Nenhum microfone encontrado. Verifique se há um microfone conectado ao seu dispositivo.", {
            autoClose: 5000,
            toastId: "no-microphone-found", // ID único para evitar duplicatas
          });
          setLoading(false);
          return;
        }
      } catch (enumError) {
        console.warn("Não foi possível enumerar dispositivos:", enumError);
        // Continuar mesmo se não conseguir enumerar
      }

      // ✅ Solicitar permissão e acessar o microfone
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      
      // ✅ Verificar se o stream tem tracks de áudio
      if (!stream.getAudioTracks().length) {
        stream.getTracks().forEach(track => track.stop());
        showErrorToast("Nenhum microfone disponível. Verifique as configurações de áudio do seu dispositivo.", {
          autoClose: 5000,
          toastId: "no-microphone-available", // ID único para evitar duplicatas
        });
        setLoading(false);
        return;
      }

      // ✅ Iniciar gravação
      await Mp3Recorder.start();
      setRecording(true);
      setLoading(false);
      
      // ✅ Parar o stream após iniciar a gravação (Mp3Recorder gerencia seu próprio stream)
      stream.getTracks().forEach(track => track.stop());
    } catch (err) {
      console.error("Erro ao iniciar gravação:", err);
      
      // ✅ Mensagens de erro mais específicas
      let errorMessage = "Erro ao acessar o microfone.";
      
      if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
        errorMessage = "Permissão de microfone negada. Por favor, permita o acesso ao microfone nas configurações do navegador.";
      } else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
        errorMessage = "Nenhum microfone encontrado. Verifique se há um microfone conectado ao seu dispositivo.";
      } else if (err.name === 'NotReadableError' || err.name === 'TrackStartError') {
        errorMessage = "O microfone está sendo usado por outro aplicativo. Feche outros aplicativos que possam estar usando o microfone.";
      } else if (err.name === 'OverconstrainedError' || err.name === 'ConstraintNotSatisfiedError') {
        errorMessage = "As configurações do microfone não são suportadas. Tente usar outro dispositivo de áudio.";
      } else if (err.message) {
        errorMessage = `Erro ao acessar o microfone: ${err.message}`;
      }
      
      // Usar toastId baseado no tipo de erro para evitar múltiplos toasts
      const errorToastId = `microphone-error-${err.name || 'unknown'}`;
      showErrorToast(errorMessage, {
        autoClose: 5000,
        toastId: errorToastId, // ID único baseado no tipo de erro
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const messages = await listQuickMessages({
        companyId,
        userId: user.id,
        isOficial: ticketChannel === "whatsapp_oficial" ? "true" : "false",
      });
      const options = messages.map((m) => {
        let truncatedMessage = m.message;
        if (isString(truncatedMessage) && truncatedMessage.length > 90) {
          truncatedMessage = m.message.substring(0, 90) + "...";
        }
        return {
          value: m.message,
          label: `/${m.shortcode} - ${truncatedMessage}`,
          mediaPath: m.mediaPath,
          mediaType: m.mediaType,
          shortcode: m.shortcode,
        };
      });
      if (isMounted.current) {
        setQuickAnswer(options);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (
      isString(inputMessage) &&
      !isEmpty(inputMessage) &&
      inputMessage.length >= 1
    ) {
      const firstWord = inputMessage.charAt(0);

      if (firstWord === "/") {
        setTypeBar(firstWord.indexOf("/") > -1);

        const filteredOptions = quickAnswers.filter(
          (m) => m.label.toLowerCase().indexOf(inputMessage.toLowerCase()) > -1
        );
        setTypeBar(filteredOptions);
      } else {
        setTypeBar(false);
      }
    } else {
      setTypeBar(false);
    }
  }, [inputMessage]);

  useEffect(() => {
    console.log("🔍 Modal state:", triggerFlowModalOpen, "Flow processing:", flowProcessing);

    // 🔥 RESET SIMPLES: Se modal fecha, libera campo
    if (!triggerFlowModalOpen && flowProcessing) {
      console.log("🔓 FORÇANDO liberação do campo");
      setFlowProcessing(false);
      flowProcessingRef.current = false;
    }
  }, [triggerFlowModalOpen, flowProcessing]);

  const disableOption = useCallback(() => {
    const isFlowProcessing = flowProcessingRef.current || flowProcessing;

    return (
      loading ||
      recording ||
      isFlowProcessing || // 🛡️ Usar tanto ref quanto estado
      needsTemplate || // ✅ Desabilitar quando precisa de template
      (!isTicketPending() && ticketStatus !== "open" && ticketStatus !== "group")
    );
  }, [loading, recording, flowProcessing, ticketStatus, needsTemplate]);

  const disableOptionForPending = useCallback(() => {
    const isFlowProcessing = flowProcessingRef.current || flowProcessing;

    return (
      loading ||
      recording ||
      isFlowProcessing || // 🛡️ Usar tanto ref quanto estado
      ticketStatus === "closed"
    );
  }, [loading, recording, flowProcessing, ticketStatus]);

  const handleUploadCamera = async (blob) => {
    setLoading(true);
    try {
      const formData = new FormData();
      const filename = `${new Date().getTime()}.png`;
      formData.append("medias", blob, filename);
      formData.append("body", (privateMessage || isTicketPending()) ? `\u200d` : "");
      formData.append("fromMe", true);

      await api.post(`/messages/${ticketId}`, formData);
      
      // ✅ Limpar loading apenas se envio foi bem sucedido
      setLoading(false);
    } catch (err) {
      // ✅ Não mostrar toastError se for erro de janela de 24h
      const errorMessage = err?.response?.data?.error || err?.message || "";
      if (!errorMessage.includes("Janela de 24h")) {
        toastError(err);
      }
      setLoading(false);
    }
  };

  // ✅ CORREÇÃO KISS: Apenas otimizar nome do arquivo para mobile
  const handleUploadAudio = async () => {
    setLoading(true);
    try {
      const [, blob] = await Mp3Recorder.stop().getMp3();
      if (blob.size < 10000) {
        setLoading(false);
        setRecording(false);
        showInfoToast("Áudio muito curto. Grave pelo menos 1 segundo de áudio.");
        return;
      }

      const formData = new FormData();

      // ✅ CORREÇÃO: Nome do arquivo otimizado para mobile
      let filename;
      if (["whatsapp", "whatsapp_oficial"].includes(ticketChannel)) {
        // Para WhatsApp, usar formato mais compatível com mobile
        filename = isMobileDevice()
          ? `audio_${new Date().getTime()}.ogg`  // OGG para mobile
          : `audio_${new Date().getTime()}.mp3`; // MP3 para desktop
      } else {
        filename = `${new Date().getTime()}.m4a`;
      }

      formData.append("medias", blob, filename);
      formData.append("body", "🎵 Mensagem de voz"); // ✅ Body mais claro
      formData.append("fromMe", true);
      formData.append("isPrivate", (privateMessage || isTicketPending()) ? "true" : "false");

      console.log(`📤 Enviando áudio: ${filename} (${blob.size} bytes)`);

      if (isMounted.current) {
        const response = await api.post(`/messages/${ticketId}`, formData);
        
        // ✅ Transcrever áudio após envio bem-sucedido (se a resposta contiver audioWids)
        if (response.data && response.data.audioWids && response.data.audioWids.length > 0) {
          // ✅ Transcrever cada áudio enviado
          response.data.audioWids.forEach((wid) => {
            // ✅ Transcrever de forma assíncrona sem bloquear
            setTimeout(async () => {
              try {
                await api.post('/message/transcribeAudio', { wid });
                console.log(`✅ Transcrição de áudio iniciada para wid: ${wid}`);
              } catch (transcribeError) {
                console.warn(`⚠️ Erro ao transcrever áudio wid ${wid} (não crítico):`, transcribeError);
                // Não mostrar erro ao usuário, transcrição é opcional
              }
            }, 2000); // ✅ Aguardar 2 segundos para garantir que a mensagem foi salva
          });
        }
      }
    } catch (err) {
      // ✅ Não mostrar toastError se for erro de janela de 24h
      const errorMessage = err?.response?.data?.error || err?.message || "";
      if (!errorMessage.includes("Janela de 24h")) {
        toastError(err);
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
        setRecording(false);
        // ✅ Restaurar foco no input após envio
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }, 100);
      }
    }
  };

  const handleCloseModalMedias = () => {
    setShowModalMedias(false);
    // ✅ Restaurar foco no input ao fechar o modal
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100);
  };

  const handleCancelAudio = async () => {
    try {
      await Mp3Recorder.stop().getMp3();
      setRecording(false);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event) => {
    setAnchorEl(null);
  };

  const handleSendContactModalOpen = async () => {
    handleMenuItemClick();
    setSenVcardModalOpen(true);
  };

  const handleCameraModalOpen = async () => {
    handleMenuItemClick();
    setModalCameraOpen(true);
  };

  const handleCancelSelection = () => {
    setMediasUpload([]);
    setShowModalMedias(false);
    // ✅ Restaurar foco no input ao cancelar seleção
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100);
  };

  const checkForSelectedText = useCallback(() => {
    if (inputRef.current) {
      const start = inputRef.current.selectionStart;
      const end = inputRef.current.selectionEnd;

      if (start !== end && start !== null && end !== null) {
        const selectedText = inputMessage.substring(start, end);
        if (selectedText.trim() !== '') {
          // Para InputBase, calcular posição baseada no elemento
          const inputRect = inputRef.current.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          setSelectedText({
            text: selectedText,
            start: start,
            end: end
          });

          setFormatMenuAnchorPosition({
            x: inputRect.left + inputRect.width / 2,
            y: inputRect.top + scrollTop - 10 // Posicionar acima do input
          });

          return true;
        }
      }
    }

    setFormatMenuAnchorPosition(null);
    return false;
  }, [inputMessage]);

  const handleCloseFormatMenu = useCallback(() => {
    setFormatMenuAnchorPosition(null);
  }, []);

  // Aplica a formatação ao texto selecionado
  const handleFormatText = useCallback((formatType) => {
    const { text, start, end } = selectedText;
    let formattedText = '';

    switch (formatType) {
      case 'bold':
        formattedText = `*${text}*`;
        break;
      case 'italic':
        formattedText = `_${text}_`;
        break;
      case 'strikethrough':
        formattedText = `~${text}~`;
        break;
      case 'code':
        formattedText = `\`${text}\``;
        break;
      case 'numberedList':
        formattedText = text.split('\n')
          .map((line, index) => `${index + 1}. ${line}`)
          .join('\n');
        break;
      case 'bulletList':
        formattedText = text.split('\n')
          .map(line => `• ${line}`)
          .join('\n');
        break;
      case 'quote':
        formattedText = text.split('\n')
          .map(line => `> ${line}`)
          .join('\n');
        break;
      case 'clear':
        formattedText = text
          .replace(/\*([^*]+)\*/g, '$1')  // remove negrito
          .replace(/_([^_]+)_/g, '$1')    // remove itálico
          .replace(/~([^~]+)~/g, '$1')    // remove tachado
          .replace(/`([^`]+)`/g, '$1')    // remove código
          .replace(/^\d+\.\s/gm, '')      // remove numeração de lista
          .replace(/^•\s/gm, '')          // remove marcadores de lista
          .replace(/^>\s/gm, '');         // remove citação
        break;
      default:
        formattedText = text;
    }

    // Substitui o texto selecionado pelo texto formatado
    const newInputMessage =
      inputMessage.substring(0, start) +
      formattedText +
      inputMessage.substring(end);

    setInputMessage(newInputMessage);

    // Fecha o menu após a formatação
    handleCloseFormatMenu();

    // Define o foco e a posição do cursor após a operação
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        const newCursorPosition = start + formattedText.length;
        inputRef.current.selectionStart = newCursorPosition;
        inputRef.current.selectionEnd = newCursorPosition;
      }
    }, 100);
  }, [selectedText, inputMessage, handleCloseFormatMenu]);

  // Handlers para detectar seleção de texto
  const handleSelectText = useCallback(() => {
    checkForSelectedText();
  }, [checkForSelectedText]);

  const handleMouseUp = useCallback(() => {
    checkForSelectedText();
  }, [checkForSelectedText]);

  const handleKeyUp = useCallback((e) => {
    // Teclas que podem alterar a seleção
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Shift') {
      checkForSelectedText();
    }
  }, [checkForSelectedText]);

  const renderReplyingMessage = (message) => {
    const mediaType = String(message?.mediaType || "").toLowerCase();
    const mediaUrl = String(message?.mediaUrl || "").toLowerCase();
    const isAudioReply =
      mediaType === "audio" ||
      mediaType === "audiomessage" ||
      /\.(mp3|wav|ogg|m4a|aac|webm)(\?|$)/.test(mediaUrl);
    const audioSource = message?.mediaUrl || "";

    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          {replyingMessage && (
            <div className={classes.replyginMsgBody}>
              {!message.fromMe && (
                <span className={classes.messageContactName}>
                  {message.contact?.name}
                </span>
              )}
              {isAudioReply ? (
                <span style={{ display: "block" }}>
                  <span>{i18n.t("messageInput.audioMessage")}</span>
                  {!!audioSource ? (
                    <AudioModal
                      url={audioSource}
                      message={message}
                      disableTranscription={true}
                    />
                  ) : null}
                </span>
              ) : message.body}
            </div>
          )}
        </div>
        <IconButton
          aria-label={i18n.t("messageInput.aria.clearReply")}
          component="span"
          disabled={disableOptionForPending()}
          onClick={() => {
            setReplyingMessage(null);
            setEditingMessage(null);
            setInputMessage("");
          }}
        >
          <Clear className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  const renderFlowProcessingAlert = () => {
    if (!flowProcessing) return null;

    return (
      <Box className={classes.pendingAlert} style={{ backgroundColor: "#E8F5E8", borderColor: "#4CAF50" }}>
        <CircularProgress size={16} style={{ marginRight: 8 }} />
        <span>
          <strong>{i18n.t("messageInput.flowProcessingAlert.title")}</strong> {i18n.t("messageInput.flowProcessingAlert.description")}
        </span>
      </Box>
    );
  };

  const renderTemplateRequiredAlert = () => {
    if (!needsTemplate || !isWhatsAppOfficial) return null;

    return (
      <Box className={classes.pendingAlert} style={{ backgroundColor: "#FFF3E0", borderColor: "#FF9800" }}>
        <WhatsApp style={{ fontSize: 20, color: "#FF9800" }} />
        <span>
          <strong>{i18n.t("messageInput.templateRequiredAlert.title")}</strong> {i18n.t("messageInput.templateRequiredAlert.description")}
        </span>
      </Box>
    );
  };

  const TextFormatMenu = () => {
    const isMenuOpen = Boolean(formatMenuAnchorPosition);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    if (!isMenuOpen) return null;

    return (
      <ClickAwayListener onClickAway={handleCloseFormatMenu}>
        <Fade in={isMenuOpen}>
          <div
            className={classes.floatingFormatMenu}
            style={{
              top: formatMenuAnchorPosition ? formatMenuAnchorPosition.y - 50 : 0,
              left: formatMenuAnchorPosition ? formatMenuAnchorPosition.x : 0,
            }}
          >
            <Tooltip title={i18n.t("messageInput.format.bold")}>
              <IconButton
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('bold')}
                size="small"
              >
                <FormatBoldIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title={i18n.t("messageInput.format.italic")}>
              <IconButton
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('italic')}
                size="small"
              >
                <FormatItalicIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title={i18n.t("messageInput.format.strikethrough")}>
              <IconButton
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('strikethrough')}
                size="small"
              >
                <FormatStrikethroughIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title={i18n.t("messageInput.format.code")}>
              <IconButton
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('code')}
                size="small"
              >
                <CodeIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title={i18n.t("messageInput.format.numberedList")}>
              <IconButton
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('numberedList')}
                size="small"
              >
                <FormatListNumberedIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title={i18n.t("messageInput.format.bulletList")}>
              <IconButton
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('bulletList')}
                size="small"
              >
                <FormatListBulletedIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title={i18n.t("messageInput.format.quote")}>
              <IconButton
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('quote')}
                size="small"
              >
                <FormatQuoteIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title={i18n.t("messageInput.format.clear")}>
              <IconButton
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('clear')}
                size="small"
              >
                <FormatClearIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>
          </div>
        </Fade>
      </ClickAwayListener>
    );
  };

  const renderPendingAlert = () => {
    if (!isTicketPending()) return null;

    return (
      <Box className={classes.pendingAlert}>
        <Info style={{ fontSize: 18 }} />
        <span>
          <strong>{i18n.t("messageInput.pendingAlert.title")}</strong> {i18n.t("messageInput.pendingAlert.description")}
        </span>
      </Box>
    );
  };

  if (mediasUpload.length > 0 && showModalMedias) {
    return (
      <Paper
        elevation={0}
        square
        className={classes.viewMediaInputWrapper}
        onDragEnter={() => setOnDragEnter(true)}
        onDrop={(e) => handleInputDrop(e)}
      >
        <MessageUploadMedias
          isOpen={showModalMedias}
          files={mediasUpload}
          onClose={handleCloseModalMedias}
          onSend={handleUploadMedia}
          onCancelSelection={handleCancelSelection}
          onAddFiles={(newFiles) => {
            // ✅ Adicionar novos arquivos à lista existente
            setMediasUpload((prevFiles) => [...prevFiles, ...newFiles]);
            // ✅ Manter o modal aberto
            setShowModalMedias(true);
          }}
        />
      </Paper>
    );
  } else {
    return (
      <>
        {templateModalOpen && (
          <TemplateModal
            open={templateModalOpen}
            handleClose={() => setTemplateModalOpen(false)}
            onSelectTemplate={(e) => handleSendMessageTemplate(e)}
            templates={templates}
          />
        )}
        {modalCameraOpen && (
          <CameraModal
            isOpen={modalCameraOpen}
            onRequestClose={() => setModalCameraOpen(false)}
            onCapture={handleCapture}
          />
        )}
        {senVcardModalOpen && (
          <ContactSendModal
            modalOpen={senVcardModalOpen}
            onClose={(c) => {
              handleSendContatcMessage(c);
            }}
          />
        )}

        {/* NOVO MODAL DE TRIGGER FLOW */}
        {triggerFlowModalOpen && (
          <TriggerFlowModal
            open={triggerFlowModalOpen}
            onClose={handleTriggerFlowClose}
            ticketId={ticketId}
            ticketStatus={ticketStatus}
            onFlowTriggered={handleFlowTriggered}
            onFlowProcessing={handleFlowProcessing}
          />
        )}

        <Paper
          square
          elevation={0}
          className={classes.mainWrapper}
          onDragEnter={() => setOnDragEnter(true)}
          onDrop={(e) => handleInputDrop(e)}
        >
          {renderPendingAlert()}
          {renderFlowProcessingAlert()}
          {renderTemplateRequiredAlert()}

          {(replyingMessage && renderReplyingMessage(replyingMessage)) ||
            (editingMessage && renderReplyingMessage(editingMessage))}
          <div className={classes.newMessageBox}>
            {/* Botão de Template destacado quando janela de 24h expirar */}
            {needsTemplate && isWhatsAppOfficial && (
              <Tooltip title={i18n.t("messageInput.tooltip.requiredTemplate")}>
                <IconButton
                  aria-label={i18n.t("messageInput.aria.sendTemplateRequired")}
                  component="span"
                  onClick={handleSendTemplate}
                  style={{
                    backgroundColor: theme.palette.primary.main,
                    color: '#fff',
                    marginRight: 8,
                    animation: 'pulse 2s infinite'
                  }}
                >
                  <WhatsApp />
                </IconButton>
              </Tooltip>
            )}

            <Hidden only={["sm", "xs"]}>
                <IconButton
                  aria-label={i18n.t("messageInput.aria.emojiPicker")}
                  component="span"
                  disabled={disableOption()}
                  onClick={(e) => setShowEmoji((prevState) => !prevState)}
                >
                  <Mood className={classes.sendMessageIcons} />
                </IconButton>
                {showEmoji ? (
                  <div className={classes.emojiBox} style={{ zIndex: 1400 }}>
                    <ClickAwayListener onClickAway={(e) => setShowEmoji(false)}>
                      <div style={{ zIndex: 1400, position: 'relative' }}>
                        <Picker
                          perLine={16}
                          theme={emojiTheme}
                          i18n={emojiMartI18n}
                          showPreview={true}
                          showSkinTones={false}
                          onSelect={handleAddEmoji}
                        />
                      </div>
                    </ClickAwayListener>
                  </div>
                ) : null}

                <Fab
                  disabled={disableOption()}
                  aria-label={i18n.t("messageInput.aria.uploadMedias")}
                  component="span"
                  className={classes.invertedFabMenu}
                  onClick={handleOpenMenuClick}
                >
                  <AddIcon />
                </Fab>
                <Menu
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleMenuItemClick}
                  id="simple-menu"
                >
                  <MenuItem onClick={handleMenuItemClick}>
                    <input
                      multiple
                      type="file"
                      id="upload-img-button"
                      accept="image/*, video/*, audio/* "
                      className={classes.uploadInput}
                      onChange={handleChangeMedias}
                    />
                    <label htmlFor="upload-img-button">
                      <Fab
                        aria-label={i18n.t("messageInput.aria.uploadMediaFile")}
                        component="span"
                        className={classes.invertedFabMenuMP}
                      >
                        <PermMedia />
                      </Fab>
                      {i18n.t("messageInput.type.imageVideo")}
                    </label>
                  </MenuItem>
                  <MenuItem onClick={handleCameraModalOpen}>
                    <Fab className={classes.invertedFabMenuCamera}>
                      <CameraAlt />
                    </Fab>
                    {i18n.t("messageInput.type.cam")}
                  </MenuItem>
                  <MenuItem onClick={handleMenuItemClick}>
                    <input
                      multiple
                      type="file"
                      id="upload-doc-button"
                      accept="application/*, text/*, .odt, .ods, .odp, .odg, .xml, .ofx, .zip, .rar, .7z, .tar, .gz, .bz2, .msg, .key, .numbers, .pages"
                      className={classes.uploadInput}
                      onChange={handleChangeMedias}
                    />
                    <label htmlFor="upload-doc-button">
                      <Fab
                        aria-label={i18n.t("messageInput.aria.uploadDocument")}
                        component="span"
                        className={classes.invertedFabMenuDoc}
                      >
                        <Description />
                      </Fab>
                      {i18n.t("messageInput.type.document")}
                    </label>
                  </MenuItem>
                  <MenuItem onClick={handleSendContactModalOpen}>
                    <Fab className={classes.invertedFabMenuCont}>
                      <Person />
                    </Fab>
                    {i18n.t("messageInput.type.contact")}
                  </MenuItem>
                  <MenuItem onClick={handleSendLinkVideo}>
                    <Fab className={classes.invertedFabMenuMeet}>
                      <Duo />
                    </Fab>
                    {i18n.t("messageInput.type.meet")}
                  </MenuItem>
                  {useWhatsappOfficial &&
                    ticketChannel === "whatsapp_oficial" && (
                      <MenuItem onClick={handleSendTemplate}>
                        <Fab 
                          className={classes.invertedFabMenuMeet}
                          style={needsTemplate ? { 
                            backgroundColor: theme.palette.primary.main,
                            color: '#fff'
                          } : {}}
                        >
                          <WhatsApp />
                        </Fab>
                        {i18n.t("messageInput.type.template")}
                        {needsTemplate && <span style={{ marginLeft: 8, color: '#FF9800' }}>⚠️</span>}
                      </MenuItem>
                    )}
                </Menu>

                {signMessagePar && (
                  <Tooltip title={i18n.t("messageInput.tooltip.signature")}>
                    <IconButton
                      aria-label={i18n.t("messageInput.aria.toggleSignature")}
                      component="span"
                      className={classes.signatureSwitchButton}
                      onClick={handleChangeSign}
                    >
                      <span
                        className={`${classes.signatureSwitchTrack} ${
                          signMessage
                            ? classes.signatureSwitchTrackOn
                            : classes.signatureSwitchTrackOff
                        }`}
                      >
                        <span
                          className={`${classes.signatureSwitchThumb} ${
                            signMessage
                              ? classes.signatureSwitchThumbOn
                              : classes.signatureSwitchThumbOff
                          }`}
                        />
                      </span>
                    </IconButton>
                  </Tooltip>
                )}

                {/* NOVO ÍCONE DE TRIGGER FLOW - APENAS EM TICKETS OPEN */}
                {ticketStatus === "open" && (
                  <Tooltip title={i18n.t("messageInput.tooltip.triggerFlow")}>
                    <IconButton
                      aria-label={i18n.t("messageInput.aria.triggerFlow")}
                      component="span"
                      onClick={handleTriggerFlowClick}
                      disabled={disableOption()}
                    >
                      <AccountTree
                        style={{
                          color: theme.mode === "light"
                            ? theme.palette.secondary.main
                            : "#EEE"
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                )}

                {isTicketPending() ? (
                  <>
                    <Tooltip title={i18n.t("messageInput.tooltip.pendingModeSwitch")}>
                      <IconButton
                        aria-label={i18n.t("messageInput.aria.pendingModeSwitch")}
                        component="span"
                        className={classes.pendingModeSwitchButton}
                        onClick={() =>
                          setPendingInputMode((prevMode) =>
                            prevMode === "internal" ? "normal" : "internal"
                          )
                        }
                      >
                        <span
                          className={`${classes.pendingModeSwitchTrack} ${
                            pendingInputMode === "internal"
                              ? classes.pendingModeSwitchTrackInternal
                              : classes.pendingModeSwitchTrackNormal
                          }`}
                        >
                          <span
                            className={`${classes.pendingModeSwitchThumb} ${
                              pendingInputMode === "internal"
                                ? classes.pendingModeSwitchThumbInternal
                                : classes.pendingModeSwitchThumbNormal
                            }`}
                          />
                          <span
                            className={`${classes.pendingModeSwitchLabel} ${
                              pendingInputMode === "normal"
                                ? classes.pendingModeSwitchLabelActive
                                : ""
                            }`}
                          >
                            N
                          </span>
                          <span
                            className={`${classes.pendingModeSwitchLabel} ${
                              pendingInputMode === "internal"
                                ? classes.pendingModeSwitchLabelActive
                                : ""
                            }`}
                          >
                            I
                          </span>
                        </span>
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={i18n.t("messageInput.tooltip.ticketNote")}>
                      <IconButton
                        aria-label={i18n.t("messageInput.aria.pendingModeNote")}
                        component="span"
                        onClick={() => setPendingInputMode("note")}
                      >
                        <Description
                          className={pendingInputMode === "note" ? classes.modeButtonActive : ""}
                        />
                      </IconButton>
                    </Tooltip>
                  </>
                ) : (
                  <Tooltip title={i18n.t("messageInput.tooltip.privateMessage")}>
                    <IconButton
                      aria-label={i18n.t("messageInput.aria.privateMessage")}
                      component="span"
                      onClick={handlePrivateMessage}
                    >
                      {privateMessage === true ? (
                        <Comment
                          style={{
                            color:
                              theme.mode === "light"
                                ? theme.palette.primary.main
                                : "#EEE",
                          }}
                        />
                      ) : (
                        <Comment style={{ color: "grey" }} />
                      )}
                    </IconButton>
                  </Tooltip>
                )}
              </Hidden>

            <Hidden only={["md", "lg", "xl"]}>
                <IconButton
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleOpenMenuClick}
                >
                  <MoreVert></MoreVert>
                </IconButton>
                <Menu
                  id="simple-menu"
                  keepMounted
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuItemClick}
                >
                  <MenuItem onClick={(e) => {
                    e.stopPropagation();
                    setShowEmoji((prevState) => !prevState);
                    handleMenuItemClick();
                  }}>
                    <IconButton
                      aria-label={i18n.t("messageInput.aria.emojiPicker")}
                      component="span"
                      disabled={disableOption()}
                    >
                      <Mood className={classes.sendMessageIcons} />
                    </IconButton>
                    Emoji
                  </MenuItem>
                  <MenuItem>
                    <input
                      multiple
                      type="file"
                      id="upload-img-button-mobile"
                      accept="image/*, video/*, audio/* "
                      disabled={disableOption()}
                      className={classes.uploadInput}
                      onChange={(e) => {
                        handleChangeMedias(e);
                        handleMenuItemClick();
                      }}
                    />
                    <label htmlFor="upload-img-button-mobile" style={{ display: 'flex', alignItems: 'center', width: '100%', cursor: 'pointer' }}>
                      <Fab
                        aria-label={i18n.t("messageInput.aria.uploadMediaFile")}
                        component="span"
                        className={classes.invertedFabMenuMP}
                        disabled={disableOption()}
                      >
                        <PermMedia />
                      </Fab>
                      <span style={{ marginLeft: 8 }}>{i18n.t("messageInput.type.imageVideo")}</span>
                    </label>
                  </MenuItem>
                  <MenuItem onClick={() => {
                    handleCameraModalOpen();
                    handleMenuItemClick();
                  }}>
                    <Fab className={classes.invertedFabMenuCamera} disabled={disableOption()}>
                      <CameraAlt />
                    </Fab>
                    {i18n.t("messageInput.type.cam")}
                  </MenuItem>
                  <MenuItem>
                    <input
                      multiple
                      type="file"
                      id="upload-doc-button-mobile"
                      accept="application/*, text/*, .odt, .ods, .odp, .odg, .xml, .ofx, .zip, .rar, .7z, .tar, .gz, .bz2, .msg, .key, .numbers, .pages"
                      disabled={disableOption()}
                      className={classes.uploadInput}
                      onChange={(e) => {
                        handleChangeMedias(e);
                        handleMenuItemClick();
                      }}
                    />
                    <label htmlFor="upload-doc-button-mobile" style={{ display: 'flex', alignItems: 'center', width: '100%', cursor: 'pointer' }}>
                      <Fab
                        aria-label={i18n.t("messageInput.aria.uploadDocument")}
                        component="span"
                        className={classes.invertedFabMenuDoc}
                        disabled={disableOption()}
                      >
                        <Description />
                      </Fab>
                      <span style={{ marginLeft: 8 }}>{i18n.t("messageInput.type.document")}</span>
                    </label>
                  </MenuItem>
                  <MenuItem onClick={() => {
                    handleSendContactModalOpen();
                    handleMenuItemClick();
                  }}>
                    <Fab className={classes.invertedFabMenuCont} disabled={disableOption()}>
                      <Person />
                    </Fab>
                    {i18n.t("messageInput.type.contact")}
                  </MenuItem>
                  <MenuItem onClick={() => {
                    handleSendLinkVideo();
                    handleMenuItemClick();
                  }}>
                    <Fab className={classes.invertedFabMenuMeet} disabled={disableOption()}>
                      <Duo />
                    </Fab>
                    {i18n.t("messageInput.type.meet")}
                  </MenuItem>
                  {useWhatsappOfficial &&
                    ticketChannel === "whatsapp_oficial" && (
                      <MenuItem onClick={() => {
                        handleSendTemplate();
                        handleMenuItemClick();
                      }}>
                        <Fab 
                          className={classes.invertedFabMenuMeet} 
                          style={needsTemplate ? { 
                            backgroundColor: theme.palette.primary.main,
                            color: '#fff'
                          } : {}}
                        >
                          <WhatsApp />
                        </Fab>
                        {i18n.t("messageInput.type.template")}
                        {needsTemplate && <span style={{ marginLeft: 8, color: '#FF9800' }}>⚠️</span>}
                      </MenuItem>
                    )}
                  {signMessagePar && (
                    <MenuItem onClick={() => {
                      handleChangeSign();
                      handleMenuItemClick();
                    }}>
                      <Tooltip title={i18n.t("messageInput.tooltip.signature")}>
                        <IconButton
                          aria-label={i18n.t("messageInput.aria.toggleSignature")}
                          component="span"
                        >
                          {signMessage === true ? (
                            <Create
                              style={{
                                color:
                                  theme.mode === "light"
                                    ? theme.palette.primary.main
                                    : "#EEE",
                              }}
                            />
                          ) : (
                            <Create style={{ color: "grey" }} />
                          )}
                        </IconButton>
                      </Tooltip>
                      {i18n.t("messageInput.type.signature")}
                    </MenuItem>
                  )}

                  {/* NOVO ITEM DE MENU MOBILE PARA TRIGGER FLOW */}
                  {ticketStatus === "open" && (
                    <MenuItem onClick={() => {
                      handleMenuItemClick();
                      handleTriggerFlowClick();
                    }}>
                      <IconButton
                        aria-label={i18n.t("messageInput.aria.triggerFlow")}
                        component="span"
                      >
                        <AccountTree
                          style={{
                            color: theme.mode === "light"
                              ? theme.palette.secondary.main
                              : "#EEE"
                          }}
                        />
                      </IconButton>
                      {i18n.t("messageInput.tooltip.triggerFlow")}
                    </MenuItem>
                  )}

                  <MenuItem onClick={() => {
                    handlePrivateMessage();
                    handleMenuItemClick();
                  }}>
                    <Tooltip title={i18n.t("messageInput.tooltip.privateMessage")}>
                      <IconButton
                        aria-label={i18n.t("messageInput.aria.privateMessage")}
                        component="span"
                      >
                        {privateMessage === true ? (
                          <Comment
                            style={{
                              color:
                                theme.mode === "light"
                                  ? theme.palette.primary.main
                                  : "#EEE",
                            }}
                          />
                        ) : (
                          <Comment style={{ color: "grey" }} />
                        )}
                      </IconButton>
                    </Tooltip>
                    Comentários
                  </MenuItem>
                </Menu>
              </Hidden>

            {/* Emoji Picker para Mobile */}
            <Hidden only={["md", "lg", "xl"]}>
              {showEmoji && (
                <div className={classes.emojiBox} style={{ 
                  bottom: 63, 
                  left: 0, 
                  right: 0, 
                  width: '100%',
                  zIndex: 9999 
                }}>
                  <ClickAwayListener onClickAway={(e) => setShowEmoji(false)}>
                    <Picker
                      perLine={7}
                      theme={emojiTheme}
                      i18n={emojiMartI18n}
                      showPreview={false}
                      showSkinTones={false}
                      onSelect={(emoji) => {
                        handleAddEmoji(emoji);
                        setShowEmoji(false);
                      }}
                      style={{ width: '100%' }}
                    />
                  </ClickAwayListener>
                </div>
              )}
            </Hidden>

            <div className={classes.flexContainer}>
              {privateMessageInputVisible && (
                <div className={classes.flexItem}>
                  <div
                    className={classes.messageInputWrapperPrivate}
                    onDragEnter={handleDragEnter}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleInputDrop}
                  >
                    <InputBase
                      inputRef={(input) => {
                        input && input.focus();
                        input && (inputRef.current = input);
                      }}
                      className={classes.messageInputPrivate}
                      placeholder={
                        ticketStatus === "open" || ticketStatus === "group"
                          ? i18n.t("messagesInput.placeholderPrivateMessage")
                          : i18n.t("messagesInput.placeholderClosed")
                      }
                      multiline
                      maxRows={5}
                      value={safeCapitalizeFirstLetter(inputMessage)}
                      onChange={handleChangeInput}
                      disabled={disableOptionForPending()}
                      onPaste={(e) => {
                        if (ticketStatus === "open" || ticketStatus === "group" || isTicketPending()) {
                          handleInputPaste(e);
                        }
                      }}
                      onKeyDown={(e) => {
                        handleKeyDown(e);
                        if (
                          e.key === "Enter" &&
                          !e.shiftKey &&
                          !isNavigatingQuickAnswers &&
                          !(maskAnchorEl && filteredMasks.length > 0)
                        ) {
                          e.preventDefault();
                          e.stopPropagation();
                          handleSendMessage();
                        }
                      }}
                      onKeyUp={handleKeyUp}
                      onMouseUp={handleMouseUp}
                      onSelect={handleSelectText}
                      spellCheck={true}
                    />
                    {/* Menu de máscaras dinâmicas */}
                    {maskAnchorEl && filteredMasks.length > 0 && (
                      <ClickAwayListener onClickAway={() => setMaskAnchorEl(null)}>
                        <Popper
                          open={true}
                          anchorEl={maskAnchorEl}
                          placement="top-start"
                          style={{ 
                            zIndex: 1300, 
                            maxWidth: "min(700px, calc(100vw - 32px))",
                            minWidth: 400,
                            marginBottom: 8 
                          }}
                          modifiers={{
                            offset: {
                              enabled: true,
                              offset: "0, 8",
                            },
                            preventOverflow: {
                              enabled: true,
                              boundariesElement: "viewport",
                            },
                          }}
                          disablePortal={false}
                        >
                        <Paper 
                          elevation={8}
                          style={{
                            maxHeight: 300,
                            overflow: "auto",
                            overflowX: "hidden",
                            boxShadow: theme.palette.mode === "dark" 
                              ? "0px 8px 24px rgba(0, 0, 0, 0.4)" 
                              : "0px 8px 24px rgba(0, 0, 0, 0.12)",
                            border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.12)"}`,
                            width: "100%",
                          }}
                        >
                          <List dense style={{ padding: 0 }}>
                            {filteredMasks.map((mask, index) => {
                              return (
                                <ListItem
                                  key={index}
                                  button
                                  onClick={() => handleMaskSelect(mask)}
                                  style={{
                                    cursor: "pointer",
                                    padding: "10px 16px",
                                    minHeight: "auto",
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <ListItemText
                                    primary={
                                      <Box style={{ 
                                        display: "flex", 
                                        flexDirection: "row", 
                                        alignItems: "center", 
                                        justifyContent: "space-between",
                                        width: "100%"
                                      }}>
                                        <Box style={{ 
                                          display: "flex", 
                                          flexDirection: "row", 
                                          alignItems: "center", 
                                          flex: 1,
                                          minWidth: 0
                                        }}>
                                          <Typography 
                                            variant="body2" 
                                            style={{ 
                                              color: theme.palette.text.primary,
                                              fontSize: "0.7rem",
                                              fontWeight: 500,
                                              lineHeight: 1.4,
                                              whiteSpace: "nowrap",
                                              marginRight: 8,
                                            }}
                                          >
                                            {mask.description}
                                          </Typography>
                                          <Typography 
                                            style={{ 
                                              color: theme.palette.primary.main,
                                              fontWeight: 600,
                                              fontSize: "0.7rem",
                                              fontFamily: "monospace",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {mask.code}
                                          </Typography>
                                        </Box>
                                        <Typography 
                                          variant="caption" 
                                          style={{ 
                                            color: theme.palette.text.secondary,
                                            fontSize: "0.65rem",
                                            display: "inline-block",
                                            padding: "2px 6px",
                                            borderRadius: 4,
                                            backgroundColor: theme.palette.mode === "dark"
                                              ? "rgba(255, 255, 255, 0.1)"
                                              : "rgba(0, 0, 0, 0.05)",
                                            flexShrink: 0,
                                            marginLeft: 8,
                                          }}
                                        >
                                          {mask.category}
                                        </Typography>
                                      </Box>
                                    }
                                    style={{ margin: 0, padding: 0, width: "100%" }}
                                  />
                                </ListItem>
                              );
                            })}
                          </List>
                        </Paper>
                        </Popper>
                      </ClickAwayListener>
                    )}
                    {typeBar ? (
                      <Box
                        component="ul"
                        className={classes.messageQuickAnswersWrapper}
                        style={{
                          marginBottom: "8px" // ✅ Pequeno espaço entre input e lista
                        }}
                      >
                        {typeBar.map((value, index) => {
                          const isSelected = selectedQuickAnswerIndex === index;
                          return (
                            <li
                              className={classes.messageQuickAnswersWrapperItem}
                              key={index}
                              style={{ listStyle: "none" }}
                            >
                              <div
                                className={clsx(
                                  classes.quickAnswerItem,
                                  isSelected && classes.quickAnswerItemSelected
                                )}
                                style={{
                                  ...getQuickAnswerItemStyle(index),
                                  // ✅ Estilo adicional para item selecionado
                                  ...(isSelected && {
                                    backgroundColor: theme.palette.primary.light + "20",
                                    borderLeft: `4px solid ${theme.palette.primary.main}`,
                                    transform: "translateX(2px)" // ✅ Leve deslocamento visual
                                  })
                                }}
                                onClick={() => handleQuickAnswersClick(value)}
                              >
                                <Box className={classes.quickAnswerText}>
                                  {value.label}
                                </Box>
                                {value.mediaType && (
                                  <Chip
                                    size="small"
                                    label={`${getMediaTypeIcon(value.mediaType)} ${value.mediaType}`}
                                    color={getMediaTypeColor(value.mediaType)}
                                    className={classes.mediaTypeChip}
                                  />
                                )}
                              </div>
                            </li>
                          );
                        })}

                        {/* ✅ Indicador de scroll apenas se necessário */}
                        {typeBar.length > 4 && (
                          <li style={{ listStyle: "none" }}>
                            <div className={classes.quickAnswersScrollIndicator}>
                              {i18n.t("messageInput.quickAnswers.keyboardHint", { count: typeBar.length })}
                            </div>
                          </li>
                        )}
                      </Box>
                    ) : null}
                  </div>
                </div>
              )}
              {((!privateMessageInputVisible && !isTicketPending()) || isTicketPending()) && (
                <div className={classes.flexItem}>
                  <div 
                    className={clsx(classes.messageInputWrapper, {
                      [classes.messageInputWrapperAccept]:
                        isTicketPending() && pendingInputMode === "normal",
                      [classes.messageInputWrapperPending]:
                        isTicketPending() &&
                        (pendingInputMode === "internal" || pendingInputMode === "note"),
                    })}
                    onDragEnter={handleDragEnter}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleInputDrop}
                  >
                    <InputBase
                      inputRef={(input) => {
                        input && input.focus();
                        input && (inputRef.current = input);
                      }}
                      className={clsx(classes.messageInput, {
                        [classes.messageInputAccept]:
                          isTicketPending() && pendingInputMode === "normal",
                        [classes.messageInputPending]:
                          isTicketPending() &&
                          (pendingInputMode === "internal" || pendingInputMode === "note"),
                      })}
                      placeholder={
                        isTicketPending()
                          ? pendingInputMode === "internal"
                            ? i18n.t("messageInput.placeholder.internalMessage")
                            : pendingInputMode === "note"
                              ? i18n.t("messageInput.placeholder.ticketNote")
                              : i18n.t("messagesInput.placeholderOpen")
                          : placeholderText
                      }
                      multiline
                      maxRows={5}
                      value={safeCapitalizeFirstLetter(inputMessage)}
                      onChange={handleChangeInput}
                      disabled={disableOption()}
                      onPaste={(e) => {
                        if (ticketStatus === "open" || ticketStatus === "group" || isTicketPending()) {
                          handleInputPaste(e);
                        }
                      }}
                      onKeyDown={(e) => {
                        handleKeyDown(e);
                        if (
                          e.key === "Enter" &&
                          !e.shiftKey &&
                          !isNavigatingQuickAnswers &&
                          !(maskAnchorEl && filteredMasks.length > 0)
                        ) {
                          e.preventDefault();
                          e.stopPropagation();
                          if (isTicketPending()) {
                            handleSendPendingByMode();
                          } else {
                            handleSendMessage();
                          }
                        }
                      }}
                      onKeyUp={handleKeyUp}
                      onMouseUp={handleMouseUp}
                      onSelect={handleSelectText}
                      spellCheck={true}
                    />
                    {/* Menu de máscaras dinâmicas */}
                    {maskAnchorEl && filteredMasks.length > 0 && (
                      <ClickAwayListener onClickAway={() => setMaskAnchorEl(null)}>
                        <Popper
                          open={true}
                          anchorEl={maskAnchorEl}
                          placement="top-start"
                          style={{ 
                            zIndex: 1400, 
                            maxWidth: "min(700px, calc(100vw - 32px))",
                            minWidth: 400,
                            marginBottom: 8 
                          }}
                          modifiers={{
                            offset: {
                              enabled: true,
                              offset: "0, 8",
                            },
                            preventOverflow: {
                              enabled: true,
                              boundariesElement: "viewport",
                            },
                          }}
                          disablePortal={false}
                        >
                          <Paper 
                            elevation={8}
                            style={{
                              maxHeight: 300,
                              overflow: "auto",
                              overflowX: "hidden",
                              boxShadow: theme.palette.mode === "dark" 
                                ? "0px 8px 24px rgba(0, 0, 0, 0.4)" 
                                : "0px 8px 24px rgba(0, 0, 0, 0.12)",
                              border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.12)"}`,
                              width: "100%",
                            }}
                          >
                            <List dense style={{ padding: 0 }}>
                              {filteredMasks.map((mask, index) => {
                                return (
                                  <ListItem
                                    key={index}
                                    button
                                    onClick={() => handleMaskSelect(mask)}
                                    style={{
                                      cursor: "pointer",
                                      padding: "10px 16px",
                                      minHeight: "auto",
                                      width: "100%",
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                    }}
                                  >
                                    <ListItemText
                                      primary={
                                        <Box style={{ 
                                          display: "flex", 
                                          flexDirection: "row", 
                                          alignItems: "center", 
                                          justifyContent: "space-between",
                                          width: "100%"
                                        }}>
                                          <Box style={{ 
                                            display: "flex", 
                                            flexDirection: "row", 
                                            alignItems: "center", 
                                            flex: 1,
                                            minWidth: 0
                                          }}>
                                            <Typography 
                                              variant="body2" 
                                              style={{ 
                                                color: theme.palette.text.primary,
                                                fontSize: "0.7rem",
                                                fontWeight: 500,
                                                lineHeight: 1.4,
                                                whiteSpace: "nowrap",
                                                marginRight: 8,
                                              }}
                                            >
                                              {mask.description}
                                            </Typography>
                                            <Typography 
                                              style={{ 
                                                color: theme.palette.primary.main,
                                                fontWeight: 600,
                                                fontSize: "0.7rem",
                                                fontFamily: "monospace",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {mask.code}
                                            </Typography>
                                          </Box>
                                          <Typography 
                                            variant="caption" 
                                            style={{ 
                                              color: theme.palette.text.secondary,
                                              fontSize: "0.65rem",
                                              display: "inline-block",
                                              padding: "2px 6px",
                                              borderRadius: 4,
                                              backgroundColor: theme.palette.mode === "dark"
                                                ? "rgba(255, 255, 255, 0.1)"
                                                : "rgba(0, 0, 0, 0.05)",
                                              flexShrink: 0,
                                              marginLeft: 8,
                                            }}
                                          >
                                            {mask.category}
                                          </Typography>
                                        </Box>
                                      }
                                      style={{ margin: 0, padding: 0, width: "100%" }}
                                    />
                                  </ListItem>
                                );
                              })}
                            </List>
                          </Paper>
                        </Popper>
                      </ClickAwayListener>
                    )}
                    {typeBar ? (
                      <ul className={classes.messageQuickAnswersWrapper}>
                        {typeBar.map((value, index) => {
                          const isSelected = selectedQuickAnswerIndex === index;
                          return (
                            <li
                              className={classes.messageQuickAnswersWrapperItem}
                              key={index}
                            >
                              <div
                                className={`${classes.quickAnswerItem} ${isSelected ? 'selected' : ''}`}
                                style={getQuickAnswerItemStyle(index)}
                                onClick={() => handleQuickAnswersClick(value)}
                              >
                                <Box className={classes.quickAnswerText}>
                                  {value.label}
                                </Box>
                                {value.mediaType && (
                                  <Chip
                                    size="small"
                                    label={`${getMediaTypeIcon(value.mediaType)} ${value.mediaType}`}
                                    color={getMediaTypeColor(value.mediaType)}
                                    className={classes.mediaTypeChip}
                                  />
                                )}
                              </div>
                            </li>
                          );
                        })}

                        {typeBar.length > 5 && (
                          <div className={classes.quickAnswersScrollIndicator}>
                            {i18n.t("messageInput.quickAnswers.scrollHint", { count: typeBar.length })}
                          </div>
                        )}
                      </ul>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {(!privateMessageInputVisible || isTicketPending()) && (
              <>
                {showSchedules && !isTicketPending() && (
                  <Tooltip title={i18n.t("tickets.buttons.scredule")}>
                    <IconButton
                      aria-label={i18n.t("messageInput.aria.scheduleMessage")}
                      component="span"
                      onClick={() => setAppointmentModalOpen(true)}
                      disabled={loading}
                    >
                      <Timer className={classes.sendMessageIcons} />
                    </IconButton>
                  </Tooltip>
                )}
                {showSelectMessageCheckbox && (
                  <>
                    <Tooltip title={i18n.t("messagesInput.cancelForward")}>
                      <IconButton
                        aria-label={i18n.t("messageInput.aria.cancelForward")}
                        component="span"
                        onClick={cancelForwardMode}
                        disabled={loading}
                      >
                        <Clear className={classes.sendMessageIcons} />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
                {inputMessage || showSelectMessageCheckbox ? (
                  <>
                    <IconButton
                      aria-label={i18n.t("messageInput.aria.sendMessage")}
                      component="span"
                      onClick={
                        showSelectMessageCheckbox
                          ? handleOpenModalForward
                          : (isTicketPending() ? handleSendPendingByMode : handleSendMessage)
                      }
                      disabled={loading}
                    >
                      {showSelectMessageCheckbox ? (
                        <Reply className={classes.ForwardMessageIcons} />
                      ) : (
                        <Send className={classes.sendMessageIcons} />
                      )}
                    </IconButton>
                  </>
                ) : recording ? (
                  <div className={classes.recorderWrapper}>
                    <IconButton
                      aria-label={i18n.t("messageInput.aria.cancelRecording")}
                      component="span"
                      fontSize="large"
                      disabled={loading}
                      onClick={handleCancelAudio}
                    >
                      <HighlightOff className={classes.cancelAudioIcon} />
                    </IconButton>
                    {loading ? (
                      <div>
                        <CircularProgress className={classes.audioLoading} />
                      </div>
                    ) : (
                      <RecordingTimer />
                    )}

                    <IconButton
                      aria-label={i18n.t("messageInput.aria.sendRecordedAudio")}
                      component="span"
                      onClick={handleUploadAudio}
                      disabled={loading}
                    >
                      <CheckCircleOutline className={classes.sendAudioIcon} />
                    </IconButton>
                  </div>
                ) : (
                  <IconButton
                    aria-label={i18n.t("messageInput.aria.showRecorder")}
                    component="span"
                    disabled={disableOptionForPending()}
                    onClick={handleStartRecording}
                  >
                    <Mic className={classes.sendMessageIcons} />
                  </IconButton>
                )}
              </>
            )}

            {privateMessageInputVisible && !isTicketPending() && (
              <>
                {showSelectMessageCheckbox && (
                  <>
                    <Tooltip title={i18n.t("messagesInput.cancelForward")}>
                      <IconButton
                        aria-label={i18n.t("messageInput.aria.cancelForward")}
                        component="span"
                        onClick={cancelForwardMode}
                        disabled={loading}
                      >
                        <Clear className={classes.sendMessageIcons} />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
                <IconButton
                  aria-label={i18n.t("messageInput.aria.sendMessage")}
                  component="span"
                  onClick={
                    showSelectMessageCheckbox
                      ? handleOpenModalForward
                      : handleSendMessage
                  }
                  disabled={loading}
                >
                  {showSelectMessageCheckbox ? (
                    <Reply className={classes.ForwardMessageIcons} />
                  ) : (
                    <Send className={classes.sendMessageIcons} />
                  )}
                </IconButton>
              </>
            )}

            {appointmentModalOpen && (
              <ScheduleModal
                open={appointmentModalOpen}
                onClose={() => setAppointmentModalOpen(false)}
                message={inputMessage}
                contactId={contactId}
                fromMessageInput={true}
                user={user}
              />
            )}

            {/* Menu de formatação que aparece quando texto é selecionado */}
            <TextFormatMenu />

          </div>
        </Paper>
      </>
    );
  }
};

export default MessageInput;
